import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import Loader from "../../utils/Loader";
import {
  company_info_add_update_action,
  get_company_info_Details_action,
  update_membership_file_action,
} from "../../actions/bookingDetails_action/companyInfo_action";
import { fill_action } from "../../actions/fillList_action";
// import slide from '../../../public/img/slide'
import {
  stateActionId,
  countryActionId,
  cityActionId,
  companyStatusActionId,
  accountTypeActionId,
  BASE_URL,
  toastSuccess,
  externalServicesActionId,
  sessionExpireMessage,
  tokenInavlidMessage,
} from "../../utils/constants";
import { ToastContainer, toast } from "react-toastify";
import {
  emailValidator,
  panNoValidator,
  gstNoValidator,
  tanNoValidator,
  notMendetoryEmailValidator,
  pincodeValidator,
  mobileNoValidator,
  notMendetoryMobileNoValidator,
} from "../../utils/Validator";
import Select from "react-select";
import Header from "../../common_components/Header";
import BookingDetailsAside from "../../common_components/booking_details/bookingDetailsAside";
import Steps from "../../common_components/booking_details/steps";
import Resizer from "react-image-file-resizer";
import { vendor_detail_action } from "../../actions/master_actions/vendor_action";
import { Button, Modal } from "react-bootstrap";
const customStyles = {
  control: (provided) => ({
    ...provided,
    borderColor: "#c9c9c9", // Blue border color
    boxShadow: "none",
    "&:hover": {
      borderColor: "#80bdff", // Blue border color on hover
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    borderRadius: "14px",
    padding: "4px",
    backgroundColor: "#00BCD4", // Blue background color for selected value
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "white", // Text color for selected value
    fontSize: "12px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    display: "none" // Remove icon color for selected value
  }),
};
const floatingLabelCSS = `
.floating-label-outside{
  top:-7px !important;
  font-size:10px !important;
  background:#fff !important;
}
`;
class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      checkboxFlag: false,
      showDetails: false,
      showPackageDetails: "",
      showImg: false,
      stateId: "",
      stateList: [],
      countryId: "",
      countryList: [],
      firstName: "",
      lastName: "",
      designation: "",
      companyName: "",
      addressLine1: "",
      addressLine2: "",
      cityId: "",
      cityList: [],
      pincode: "",
      Mobile1: "",
      Mobile2: "",
      primaryEmailID: "",
      secondaryEmailID: "",
      website: "",
      mobileISD1: "",
      mobileISD2: "",
      accountType: "",
      accountTypeList: [],

      SameAsAbove: false,

      SAAFirstName: "",
      SAALastName: "",
      SAADesignation: "",
      SAACompanyName: "",
      SAAAddressLine1: "",
      SAAAddressLine2: "",
      SAACityId: "",
      SAAPincode: "",
      SAAMobile1: "",
      SAAMobile2: "",
      SAAPrimaryEmailID: "",
      SAASecondaryEmailID: "",
      SAAWebsite: "",
      SAAStateId: "",
      SAACountryId: "",
      SAATelephoneNumber: "",
      SAAMobileISD1: "",
      SAAMobileISD2: "",
      SAAISD: "",
      registrationNumber: "",
      PANCardNo: "",
      NameonPANCard: "",
      GSTNo: "",
      CompanyStatus: "",
      TANNumber: "",
      UINNumber: "",
      TelephoneNumber: "",

      bookingList: JSON.parse(sessionStorage.getItem("bookArray")),

      accountName: "",
      accountNo: "",
      accountType: "",
      bankName: "",
      branchName: "",
      IFSCCode: "",

      CityName: "",
      tempCityList: [],
      SAACityName: "",
      companyStatusId: "",
      companyStatusList: [],
      ISD: "",

      CenterID: "",
      OrderID: "",
      ClientID: "",
      Is_CenterID: false,
      MaxPAX: "",
      LastDate: "",

      formFile: "",
      formFileType: "",
      fileName: sessionStorage.getItem("fileName"),
      memershipFilePath: "",
      checkboxFlag:
        sessionStorage.getItem("checkboxFlag") == "true" ? true : false,

      dummyFileName: "",

      // input validate
      companyStatusErr: "",
      firstNameErr: "",
      lastNameErr: "",
      organizerErr: "",
      addressLine1Err: "",
      CityNameErr: "",
      countryIdErr: "",
      pincodeErr: "",
      Mobile1Err: "",
      primaryEmailIDErr: "",
      SAAFirstNameErr: "",
      SAALastNameErr: "",
      SAAAddressLine1Err: "",
      SAACityNameErr: "",
      SAACountryIdErr: "",
      SAAPincodeErr: "",
      SAAMobile1Err: "",
      SAAPrimaryEmailIDErr: "",
      PANCardNoErr: "",
      NameonPANCardErr: "",
      accountNameErr: "",
      accountNoErr: "",
      accountTypeErr: "",
      bankNameErr: "",
      branchNameErr: "",
      IFSCCodeErr: "",
      SAACompanyNameErr: "",

      isDisplayCityList: false,
      isSAADisplayCityList: false,

      isDisplayStateList: false,
      tempStateList: [],

      isSAADisplayStateList: false,
      tempSAAStateList: [],

      SAAStateList: [],
      SAAtempStateList: [],

      SAACityList: [],
      SAAtempCityList: [],
      preTel: "",
      SAAPreTel: "",
      downloadUrl: "",

      EventCordinatorName: "",
      EventCordinatorDesignation: "",
      EventCordinatorEmail: "",
      EventCordinatorMobile: "",
      PrimaryContactName: "",
      PrimaryContactDesignation: "",
      PrimaryContactEmail: "",
      PrimaryContactMobile: "",

      EventCordinatorNameErr: "",
      EventCordinatorDesignationErr: "",
      EventCordinatorEmailErr: "",
      EventCordinatorMobileErr: "",
      PrimaryContactNameErr: "",
      PrimaryContactDesignationErr: "",
      PrimaryContactEmailErr: "",
      PrimaryContactMobileErr: "",

      isEditMode: true,
      TypeOfEventList: [],
      editIndex: "",
      editedRowIndexServicePackage: "",
      editedRowServicePackage: "",
      servicePackageList: [],
      servicePackageDetails: {
        VendorServicePackageID: null,
        ServiceID: "",
        City: "",
        Package: "",
        PackageDetails: "",
        ITME_Margin: "",
        previewImagesInput: [],
      },
      VendorServicePackageImageID: "",
      materialList:[],
      VendorID: "",
      FilePath: [],
      previewImagesInput: [],
      servicePhotoList: [],
      //nodeimage
      packageImageList: [],
      formFile: "",
      fileName: "",
      formFileType: "",
      VendorServicePackageID: null,
      ServiceID: "",
      City: "",
      Package: "",
      PackageDetails: "",
      Price_In_INR: "",
      Price_In_USD: "",
      ITME_CutOff_Limit: "",
      ITME_Margin: "",
      password: "",
      confPassword: "",
      passwordErr: "",
      confPasswordErr: "",
      ExternalServicesID: "",
      ExternalServices: "",
      ExternalServicesList: [],
      ExternalServicesListTable: [],
      isVendorLogin: false,
      AreaCode: '',
      SAAAreaCode: ''
    };
  }

  componentDidMount = () => {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }

    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const VendorID = sessionStorage.getItem("VendorID")
      ? parseInt(sessionStorage.getItem("VendorID"))
      : null;
    this.setState({ VendorID: VendorID });
    const sortUrl = BASE_URL.split("/api");

    this.setState({ downloadUrl: sortUrl[0] });

    this.getFillList(stateActionId, "", 91, "");
    this.getFillList(countryActionId, "", 1, "");
    this.getFillList(cityActionId, "", 91, "");
    this.getFillList(companyStatusActionId, "", "", "");
    this.getFillList(accountTypeActionId, "", "", "");
    this.getFillList(externalServicesActionId, "", "", "", "");

    setTimeout(() => {
      if (sessionStorage.getItem("roleId") == 13) {
        this.setState({ isVendorLogin: true });
        this.vendorDetails();
      } else {
        this.setState({ isVendorLogin: false });
        this.getCompanyInfoDetails();
      }
    }, 100);

    this.setState({
      OrderID:
        this.props.location.state != null &&
          this.props.location.state.OrderID != null
          ? this.props.location.state.OrderID
          : "",

      CenterID:
        this.props.location.state != null &&
          this.props.location.state.CenterID != null
          ? this.props.location.state.CenterID
          : "",

      ClientID:
        this.props.location.state != null &&
          this.props.location.state.ClientID != null
          ? this.props.location.state.ClientID
          : "",

      Is_CenterID:
        this.props.location.state != null &&
          this.props.location.state.Is_CenterID != null
          ? this.props.location.state.Is_CenterID
          : "",

      LastDate:
        this.props.location.state != null &&
          this.props.location.state.LastDate != null
          ? this.props.location.state.LastDate
          : "",
    });

    setTimeout(() => {
      if (this.state.Is_CenterID == true && this.state.bookingList != null) {
        this.setState({
          CenterID: this.state.bookingList[0]["CenterID"],
        });
        {
          console.log("CenterID", this.state.bookingList[0]["CenterID"]);
        }
        sessionStorage.setItem(
          "CenterID",
          this.state.bookingList[0]["CenterID"]
        );
        for (let i = 0; i < this.state.bookingList.length; i++) {
          if (this.state.bookingList.length - 1 == i) {
            // console.log("this.state.bookingList[i]['Date']", this.state.bookingList[i]['Date'])
            this.props.location.state.Is_CenterID == true ? (
              this.setState({ LastDate: this.state.bookingList[i]["Date"] })
            ) : (
              <></>
            );
          }
        }
      }
    }, 10);

    console.log("");
  };

  getFillList(value, userID, keyword, keyvalue) {
    // this.setState({ isLoading: true })
    this.props
      .fill_action(
        value,
        userID == "" || userID == null ? null : userID,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (value == stateActionId) {
            this.setState({
              stateList: data.data,
              tempStateList: data.data,

              SAAStateList: data.data,
              SAAtempStateList: data.data,
            });
            console.log("stateActionId", data.data);
          }
          if (value == countryActionId) {
            this.setState({ countryList: data.data, isLoading: false });
            console.log("countryActionId", data.data);
          }
          if (value == cityActionId) {
            this.setState({
              cityList: data.data,
              tempCityList: data.data,

              SAACityList: data.data,
              SAAtempCityList: data.data,
            });
            console.log("cityActionId", data.data);
          }
          if (value == companyStatusActionId) {
            this.setState({ companyStatusList: data.data, isLoading: false });
          }
          if (value == accountTypeActionId) {
            this.setState({ accountTypeList: data.data, isLoading: false });
            console.log("accountTypeActionId", data.data);
          }
          if (value == externalServicesActionId) {
            var tempExtServArr = [];
            for (var i = 0; i < data.data.length; i++) {
              var extSerObj = {};
              extSerObj.label = data.data[i].ExternalServices;
              extSerObj.value = data.data[i].ExternalServicesID;
              tempExtServArr.push(extSerObj);
            }
            this.setState({
              ExternalServicesList: tempExtServArr,
              isLoading: false,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // search city
  onCitytSearch(e) {
    const {
      cityList,
      tempCityList,
      billTempCityList,
      cityId,
      countryId,
      SameAsAbove,
    } = this.state;
    if (countryId == "91" || countryId == "" || countryId == "Country*") {
      if (e.target.value != "") {
        var searchCityList = tempCityList.filter((data) => {
          return data.CityName.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          cityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          CityNameErr: "",
          tempCityList: searchCityList,
          isDisplayCityList: true,
        });
      } else {
        this.setState({
          cityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          tempCityList: cityList,
          isDisplayCityList: false,
        });
      }
      if (SameAsAbove) {
        this.setState({
          SAACityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAACityNameErr: "",
        });
      }
    } else {
      this.setState({
        cityId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        isDisplayCityList: false,
      });
      if (SameAsAbove) {
        this.setState({
          SAACityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAACityNameErr: "",
        });
      }
    }
  }

  // render city
  renderCityList() {
    const { tempCityList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 100 }}
      >
        {tempCityList.length > 0 &&
          tempCityList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={() => this.mainCityListData(data)}
            >
              {data.CityName}
            </li>
          ))}
      </ul>
    );
  }

  mainCityListData(data) {
    const { SameAsAbove } = this.state;
    this.setState({
      cityId: data.CityName,
      isDisplayCityList: false,
      CityNameErr: "",
    });

    if (SameAsAbove) {
      this.setState({ SAACityId: data.CityName, SAACityNameErr: "" });
    }
  }
  // same as above search city
  onSAACitytSearch(e) {
    const {
      SAACityList,
      SAAtempCityList,
      billTempCityList,
      cityId,
      SAACountryId,
    } = this.state;
    if (
      SAACountryId == "91" ||
      SAACountryId == "" ||
      SAACountryId == "Country*"
    ) {
      console.log("SAAtempCityList +++++++++++++++++", SAAtempCityList);
      if (e.target.value != "") {
        var searchCityList = SAAtempCityList.filter((data) => {
          return data.CityName.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          SAACityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAACityNameErr: "",
          SAAtempCityList: searchCityList,
          isSAADisplayCityList: true,
        });
      } else {
        this.setState({
          SAACityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAAtempCityList: SAACityList,
          isSAADisplayCityList: false,
        });
      }
    } else {
      this.setState({
        SAACityId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        isSAADisplayCityList: false,
      });
    }
  }
  // same as above render city
  renderSAACityList() {
    const { SAAtempCityList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 100 }}
      >
        {SAAtempCityList.length > 0 &&
          SAAtempCityList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={() => this.mainSAACityListData(data)}
            >
              {data.CityName}
            </li>
          ))}
      </ul>
    );
  }
  mainSAACityListData(data) {
    this.setState({
      SAACityId: data.CityName,
      isSAADisplayCityList: false,
      SAACityNameErr: "",
    });
  }
  // search State
  onStateSearch(e) {
    const { stateList, tempStateList, SameAsAbove, countryId } = this.state;
    console.log("countryId -------------------onStateSearch", countryId);
    if (countryId == "91" || countryId == "" || countryId == "Country*") {
      if (e.target.value != "") {
        var searchStateList = tempStateList.filter((data) => {
          return data.Description.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          stateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          stateErr: "",
          tempStateList: searchStateList,
          isDisplayStateList: true,
        });
      } else {
        this.setState({
          stateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          stateErr: "",
          tempStateList: stateList,
          isDisplayStateList: false,
        });
      }
      if (SameAsAbove) {
        this.setState({
          SAAStateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAAStateErr: "",
        });
      }
    } else {
      this.setState({
        stateId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        isDisplayStateList: false,
      });
      if (SameAsAbove) {
        this.setState({
          SAAStateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAAStateErr: "",
        });
      }
    }
  }
  // render State
  renderStateList() {
    const { tempStateList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 100 }}
      >
        {tempStateList.length > 0 &&
          tempStateList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={() => this.mainStateListData(data)}
            >
              {data.Description}
            </li>
          ))}
      </ul>
    );
  }
  mainStateListData(data) {
    const { SameAsAbove } = this.state;
    this.setState({
      stateId: data.Description,
      isDisplayStateList: false,
      stateErr: "",
    });

    if (SameAsAbove) {
      this.setState({ SAAStateId: data.Description, SAAStateErr: "" });
    }
  }
  // same as above search State
  onSAAStateSearch(e) {
    const { SAAStateList, tempSAAStateList, isDisplayStateList, SAACountryId } =
      this.state;
    if (
      SAACountryId == "91" ||
      SAACountryId == "" ||
      SAACountryId == "Country*"
    ) {
      if (e.target.value != "") {
        var searchStateList = tempSAAStateList.filter((data) => {
          return data.Description.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          SAAStateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAAStateErr: "",
          tempSAAStateList: searchStateList,
          isSAADisplayStateList: true,
        });
      } else {
        this.setState({
          SAAStateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          tempSAAStateList: SAAStateList,
          isSAADisplayStateList: false,
        });
      }
    } else {
      this.setState({
        SAAStateId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        isSAADisplayStateList: false,
      });
    }
  }
  //same as above render State
  renderSAAStateList() {
    const { tempSAAStateList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 100 }}
      >
        {tempSAAStateList.length > 0 &&
          tempSAAStateList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={() => this.mainSAAStateListData(data)}
            >
              {data.Description}
            </li>
          ))}
      </ul>
    );
  }
  mainSAAStateListData(data) {
    this.setState({
      SAAStateId: data.Description,
      isSAADisplayStateList: false,
      stateErr: "",
    });
  }
  SameAsAbove(e) {
    const {
      SameAsAbove,
      firstName,
      lastName,
      designation,
      TelephoneNumber,
      addressLine1,
      addressLine2,
      city,
      pincode,
      Mobile1,
      Mobile2,
      ISD,
      STD,
      primaryEmailID,
      secondaryEmailID,
      website,
      mobileISD1,
      mobileISD2,
      stateId,
      countryId,
      CityName,
      companyName,
      cityId,
      preTel,
    } = this.state;
    this.setState({ SameAsAbove: !SameAsAbove });
    if (!SameAsAbove) {
      this.setState({
        SAAFirstName: firstName,
        SAALastName: lastName,
        SAADesignation: designation,
        SAACompanyName: companyName,
        SAAAddressLine1: addressLine1,
        SAAAddressLine2: addressLine2,
        SAACityId: cityId,
        SAAPincode: pincode,
        SAAMobile1: Mobile1,
        SAAMobile2: Mobile2,
        SAAISD: ISD,
        SAASTD: STD,
        SAAPrimaryEmailID: primaryEmailID,
        SAASecondaryEmailID: secondaryEmailID,
        SAAWebsite: website,
        SAAStateId: stateId,
        SAACountryId: countryId,
        SAATelephoneNumber: TelephoneNumber,
        SAAMobileISD1: mobileISD1,
        SAAMobileISD2: mobileISD2,
        SAAPreTel: preTel,

        SAAFirstNameErr: "",
        SAALastNameErr: "",
        SAACompanyNameErr: "",
        SAAAddressLine1Err: "",
        SAACityNameErr: "",
        SAACountryIdErr: "",
        SAAPincodeErr: "",
        SAAMobile1Err: "",
        SAAPrimaryEmailIDErr: "",
        SAAStateErr: "",
      });
      console.log("stateId", stateId);
      console.log("countryId", countryId);
    } else {
      this.setState({
        SAAFirstName: "",
        SAALastName: "",
        SAADesignation: "",
        SAACompanyName: "",
        SAAAddressLine1: "",
        SAAAddressLine2: "",
        SAACityId: "",
        SAAPincode: "",
        SAAMobile1: "",
        SAAMobile2: "",
        SAAISD: "",
        SAASTD: "",
        SAAPrimaryEmailID: "",
        SAASecondaryEmailID: "",
        SAAWebsite: "",
        SAAStateId: "",
        SAACountryId: "",
        SAATelephoneNumber: "",
        SAAMobileISD1: "",
        SAAMobileISD2: "",
        SAACityId: "",
        SAAPreTel: "",
      });
    }
  }
  inputValidate() {
    const {
      firstName,
      lastName,
      designation,
      companyName,
      addressLine1,
      addressLine2,
      stateId,
      cityId,
      cityList,
      pincode,
      Mobile1,
      Mobile2,
      ISD,
      primaryEmailID,
      secondaryEmailID,
      website,
      SameAsAbove,
      SAAFirstName,
      SAALastName,
      SAADesignation,
      SAAAddressLine1,
      SAAAddressLine2,
      SAACityId,
      SAAPincode,
      SAAMobile1,
      SAAMobile2,
      SAAISD,
      SAASTD,
      SAAPrimaryEmailID,
      SAASecondaryEmailID,
      SAAWebsite,
      SAAStateId,
      registrationNumber,
      PANCardNo,
      NameonPANCard,
      GSTNo,
      CompanyStatus,
      TANNumber,
      UINNumber,
      SAATelephoneNumber,
      TelephoneNumber,
      SAACountryId,
      mobileISD1,
      mobileISD2,
      SAAMobileISD1,
      SAAMobileISD2,
      isDisplayCityList,
      CityName,
      SAACityName,
      companyStatusId,
      companyStatusList,
      CenterID,
      accountName,
      accountNo,
      accountType,
      bankName,
      branchName,
      IFSCCode,
      countryId,
      SAACompanyName,
      EventCordinatorName,
      EventCordinatorDesignation,
      EventCordinatorEmail,
      EventCordinatorMobile,
      PrimaryContactName,
      PrimaryContactDesignation,
      PrimaryContactEmail,
      PrimaryContactMobile,
    } = this.state;

    if (
      companyStatusId == "" ||
      companyStatusId == null ||
      companyStatusId == "Select"
    ) {
      this.setState({ companyStatusErr: "Please select organizer status" });
    }
    if (firstName == "" || firstName == null) {
      this.setState({ firstNameErr: "Please enter first name" });
    }
    if (lastName == "" || lastName == null) {
      this.setState({ lastNameErr: "Please enter last name" });
    }
    if (companyName == "" || companyName == null) {
      this.setState({ organizerErr: "Please enter organizer name" });
    }
    if (addressLine1 == "" || addressLine1 == null) {
      this.setState({ addressLine1Err: "Please enter address line 1" });
    }
    if (cityId == "" || cityId == null) {
      this.setState({
        CityNameErr: "Please enter city",
        isDisplayCityList: false,
      });
    }
    if (stateId == "" || stateId == null) {
      this.setState({ stateErr: "Please select state" });
    }
    if (countryId == "" || countryId == "Country*" || countryId == null) {
      this.setState({ countryIdErr: "Please select country" });
    }
    if (pincode == "" || pincode == null) {
      if (countryId == "91" || countryId == "" || countryId == "Country*") {
        this.setState({ pincodeErr: "Please enter pincode" });
      } else {
        this.setState({ pincodeErr: "Please enter zipCode" });
      }
    }
    if (Mobile1 == "" || Mobile1 == null) {
      this.setState({ Mobile1Err: "Please enter mobile number" });
    }
    if (primaryEmailID == "" || primaryEmailID == null) {
      this.setState({ primaryEmailIDErr: "Please enter email id" });
    }
    if (SAAFirstName == "" || SAAFirstName == null) {
      this.setState({ SAAFirstNameErr: "Please enter first name" });
    }
    if (SAALastName == "" || SAALastName == null) {
      this.setState({ SAALastNameErr: "Please enter last name" });
    }
    if (SAACompanyName == "" || SAACompanyName == null) {
      this.setState({ SAACompanyNameErr: "Please enter organizer name" });
    }
    if (SAAAddressLine1 == "" || SAAAddressLine1 == null) {
      this.setState({ SAAAddressLine1Err: "Please enter address line 1" });
    }
    if (SAACityId == "" || SAACityId == null) {
      this.setState({
        SAACityNameErr: "Please enter city",
        isSAADisplayCityList: false,
      });
    }
    if (SAAStateId == "" || SAAStateId == null) {
      this.setState({ SAAStateErr: "Please select state" });
    }
    if (
      SAACountryId == "" ||
      SAACountryId == "Country*" ||
      SAACountryId == null
    ) {
      this.setState({ SAACountryIdErr: "Please select country" });
    }
    if (SAAPincode == "" || SAAPincode == null) {
      if (
        SAACountryId == "91" ||
        SAACountryId == "" ||
        SAACountryId == "Country*"
      ) {
        this.setState({ SAAPincodeErr: "Please enter pincode" });
      } else {
        this.setState({ SAAPincodeErr: "Please enter zipCode" });
      }
    }
    if (SAAMobile1 == "" || SAAMobile1 == null) {
      this.setState({ SAAMobile1Err: "Please enter mobile number" });
    }
    if (SAAPrimaryEmailID == "" || SAAPrimaryEmailID == null) {
      this.setState({ SAAPrimaryEmailIDErr: "Please enter email id" });
    }
    if (PANCardNo == "" || PANCardNo == null) {
      this.setState({ PANCardNoErr: "Please enter pancard number" });
    }
    if (NameonPANCard == "" || NameonPANCard == null) {
      this.setState({ NameonPANCardErr: "Please enter name on pancard" });
    }
    if (accountName == "" || accountName == null) {
      this.setState({ accountNameErr: "Please enter account name" });
    }
    if (accountNo == "" || accountNo == null) {
      this.setState({ accountNoErr: "Please enter account number" });
    }
    if (
      accountType == "" ||
      accountType == "Select" ||
      accountType == "Account Type*" ||
      accountType == null
    ) {
      this.setState({ accountTypeErr: "Please select account type" });
    }
    if (bankName == "" || bankName == null) {
      this.setState({ bankNameErr: "Please enter bank name" });
    }
    if (branchName == "" || branchName == null) {
      this.setState({ branchNameErr: "Please enter branch name" });
    }
    if (IFSCCode == "" || IFSCCode == null) {
      if (countryId == "91" || countryId == "" || countryId == "Country*") {
        this.setState({ IFSCCodeErr: "Please enter IFSC code" });
      } else {
        this.setState({ IFSCCodeErr: "Please enter Swift code" });
      }
    }

    // event Cordinator details
    if (EventCordinatorName == "" || EventCordinatorName == null) {
      this.setState({
        EventCordinatorNameErr: "Please enter event cordinator name",
      });
    }
    if (
      EventCordinatorDesignation == "" ||
      EventCordinatorDesignation == null
    ) {
      this.setState({
        EventCordinatorDesignationErr:
          "Please enter event cordinator designation",
      });
    }
    if (EventCordinatorEmail == "" || EventCordinatorEmail == null) {
      this.setState({
        EventCordinatorEmailErr: "Please enter event cordinator email",
      });
    }

    if (EventCordinatorMobile == "" || EventCordinatorMobile == null) {
      this.setState({
        EventCordinatorMobileErr: "Please enter event cordinator mobile no",
      });
    }

    // primary contact details
    if (PrimaryContactName == "" || PrimaryContactName == null) {
      this.setState({
        PrimaryContactNameErr: "Please enter primary contact name",
      });
    }
    if (PrimaryContactDesignation == "" || PrimaryContactDesignation == null) {
      this.setState({
        PrimaryContactDesignationErr:
          "Please enter primary contact designation",
      });
    }
    if (PrimaryContactEmail == "" || PrimaryContactEmail == null) {
      this.setState({
        PrimaryContactEmailErr: "Please enter primary contact email",
      });
    }
    if (PrimaryContactMobile == "" || PrimaryContactMobile == null) {
      this.setState({
        PrimaryContactMobileErr: "Please enter primary contact mobile no",
      });
    }
  }

  mobileCheckedSameOrNot() {
    const { Mobile1, EventCordinatorMobile, PrimaryContactMobile } = this.state;
    if (Mobile1 == EventCordinatorMobile) {
      this.setState({
        EventCordinatorMobileErr:
          "Provide Different Contact Number for Event Coordinator",
      });
    }
    if (Mobile1 == PrimaryContactMobile) {
      this.setState({ PrimaryContactMobileErr: "Mobile No can not be same" });
    }
  }
  togglePackageDetailsModal(PackageDetails, Package) {
    this.setState((prevState) => ({
      showDetails: !prevState.showDetails,
      showPackageDetails: PackageDetails ? PackageDetails : "",
      Package: Package ? Package : "",
    }));
    console.log(PackageDetails, Package);
  }

  handleSubmit() {
    const {
      firstName,
      lastName,
      designation,
      companyName,
      addressLine1,
      addressLine2,
      stateId,
      countryId,
      pincode,
      Mobile1,
      Mobile2,
      TelephoneNumber,
      primaryEmailID,
      secondaryEmailID,
      website,
      SameAsAbove,
      SAAFirstName,
      SAALastName,
      SAADesignation,
      SAAAddressLine1,
      SAAAddressLine2,
      cityId,
      SAAStateId,
      SAACountryId,
      SAAPincode,
      SAAMobile1,
      SAAMobile2,
      SAATelephoneNumber,
      SAAPrimaryEmailID,
      SAASecondaryEmailID,
      SAAWebsite,
      registrationNumber,
      PANCardNo,
      NameonPANCard,
      GSTNo,
      CompanyStatus,
      TANNumber,
      UINNumber,
      SAACityId,
      CityName,
      cityList,
      SAACityName,
      companyStatusId,
      ClientID,
      accountName,
      accountNo,
      accountType,
      bankName,
      branchName,
      IFSCCode,
      CenterID,
      bookingList,
      SAACompanyName,
      SAAPreTel,
      preTel,
      is_Update_Membership,
      EventCordinatorName,
      EventCordinatorDesignation,
      EventCordinatorEmail,
      EventCordinatorMobile,
      PrimaryContactName,
      PrimaryContactDesignation,
      PrimaryContactEmail,
      PrimaryContactMobile,
      AreaCode,
      SAAAreaCode
    } = this.state;
    const isEdit =
      this.props.location.state != null &&
        this.props.location.state.isEdit != null
        ? this.props.location.state.isEdit
        : null;

    const OrderID =
      this.props.location.state != null &&
        this.props.location.state.OrderID != null
        ? this.props.location.state.OrderID
        : "";
    setTimeout(() => {
      this.inputValidate();
    }, 100);
    if (countryId == "91") {
      if (
        firstName != "" &&
        firstName != null &&
        lastName != "" &&
        lastName != null &&
        companyName != "" &&
        companyName != null &&
        addressLine1 != "" &&
        addressLine1 != null &&
        stateId != null &&
        stateId != "" &&
        countryId != "" &&
        countryId != null &&
        countryId == "91" &&
        countryId != "Country*" &&
        cityId != "" &&
        cityId != null &&
        pincode != "" &&
        pincode != null &&
        Mobile1 != "" &&
        Mobile1 != null &&
        primaryEmailID != "" &&
        primaryEmailID != null &&
        SAAFirstName != "" &&
        SAAFirstName != null &&
        SAALastName != "" &&
        SAALastName != null &&
        SAACompanyName != "" &&
        SAACompanyName != null &&
        SAAAddressLine1 != "" &&
        SAAAddressLine1 != null &&
        SAACountryId != "" &&
        SAACountryId != null &&
        SAACountryId != "Country*" &&
        SAAStateId != null &&
        SAAStateId != "" &&
        SAACityId != "" &&
        SAACityId != null &&
        SAAPincode != "" &&
        SAAPincode != null &&
        SAAMobile1 != "" &&
        SAAMobile1 != null &&
        SAAPrimaryEmailID != "" &&
        SAAPrimaryEmailID != null &&
        PANCardNo != "" &&
        PANCardNo != null &&
        NameonPANCard != "" &&
        NameonPANCard != null &&
        companyStatusId != "" &&
        companyStatusId != null &&
        companyStatusId != "Select" &&
        accountName != "" &&
        accountName != null &&
        accountNo != "" &&
        accountNo != null &&
        accountType != "" &&
        accountType != null &&
        accountType != "Select" &&
        accountType != "Account Type*" &&
        bankName != "" &&
        bankName != null &&
        branchName != "" &&
        branchName != null &&
        IFSCCode != "" &&
        IFSCCode != null &&
        EventCordinatorName != "" &&
        EventCordinatorName != null &&
        EventCordinatorDesignation != "" &&
        EventCordinatorDesignation != null &&
        EventCordinatorEmail != "" &&
        EventCordinatorEmail != null &&
        EventCordinatorMobile != "" &&
        EventCordinatorMobile != null &&
        PrimaryContactName != "" &&
        PrimaryContactName != null &&
        PrimaryContactDesignation != "" &&
        PrimaryContactDesignation != null &&
        PrimaryContactEmail != "" &&
        PrimaryContactEmail != null &&
        PrimaryContactMobile != "" &&
        PrimaryContactMobile != null
      ) {
        var errMsg1 = emailValidator(primaryEmailID);
        var errMsg2 = notMendetoryEmailValidator(secondaryEmailID);
        var errMsg3 = emailValidator(SAAPrimaryEmailID);
        var errMsg4 = notMendetoryEmailValidator(SAASecondaryEmailID);
        var panErrMsg = panNoValidator(PANCardNo);
        var gstErrMsg = gstNoValidator(GSTNo);
        var tanErrMsg = tanNoValidator(TANNumber);
        var pincodeErrMsg = pincodeValidator(pincode);
        var pincodeSaaErrMsg = pincodeValidator(SAAPincode);
        var mobile1ErrMsg = mobileNoValidator(Mobile1);
        var mobile2ErrMsg = notMendetoryMobileNoValidator(Mobile2);
        var SAAMobile1ErrMsg = mobileNoValidator(SAAMobile1);
        var SAAMobile2ErrMsg = notMendetoryMobileNoValidator(SAAMobile2);
        var EventCordinatorMobileErrMsg = mobileNoValidator(
          EventCordinatorMobile
        );
        var PrimaryContactMobileErrMsg =
          mobileNoValidator(PrimaryContactMobile);
        var EventCordinatorEmailErrMsg = emailValidator(EventCordinatorEmail);
        var PrimaryContactEmailErrMsg = emailValidator(PrimaryContactEmail);

        if (
          errMsg1 != "" ||
          errMsg3 != "" ||
          panErrMsg != "" ||
          pincodeErrMsg != "" ||
          pincodeSaaErrMsg != "" ||
          mobile1ErrMsg != "" ||
          SAAMobile1ErrMsg != "" ||
          EventCordinatorMobileErrMsg != "" ||
          PrimaryContactMobileErrMsg != "" ||
          EventCordinatorEmailErrMsg != "" ||
          PrimaryContactEmailErrMsg != ""
        ) {
          toast.error(
            errMsg1 != ""
              ? errMsg1
              : errMsg3 != ""
                ? errMsg3
                : panErrMsg != ""
                  ? panErrMsg
                  : pincodeErrMsg != ""
                    ? pincodeErrMsg
                    : pincodeSaaErrMsg != ""
                      ? pincodeSaaErrMsg
                      : mobile1ErrMsg != ""
                        ? mobile1ErrMsg
                        : SAAMobile1ErrMsg != ""
                          ? SAAMobile1ErrMsg
                          : EventCordinatorMobileErrMsg != ""
                            ? EventCordinatorMobileErrMsg
                            : PrimaryContactMobileErrMsg != ""
                              ? PrimaryContactMobileErrMsg
                              : EventCordinatorEmailErrMsg != ""
                                ? EventCordinatorEmailErrMsg
                                : PrimaryContactEmailErrMsg != ""
                                  ? PrimaryContactEmailErrMsg
                                  : "",
            {
              position: "top-center",
              theme: "colored",
              autoClose: 1000,
              hideProgressBar: true,
            }
          );

          if (errMsg1) {
            this.setState({ primaryEmailIDErr: "Please enter proper email" });
          } else if (errMsg3) {
            this.setState({
              SAAPrimaryEmailIDErr: "Please enter proper email",
            });
          } else if (panErrMsg) {
            this.setState({ PANCardNoErr: "Please enter proper PAN No" });
          } else if (pincodeErrMsg) {
            this.setState({ pincodeErr: "Please Enter proper pincode" });
          } else if (pincodeSaaErrMsg) {
            this.setState({ SAAPincodeErr: "Please Enter proper pincode" });
          } else if (mobile1ErrMsg) {
            this.setState({ Mobile1Err: "Please Enter proper mobile number" });
          } else if (SAAMobile1ErrMsg) {
            this.setState({
              SAAMobile1Err: "Please Enter proper mobile number",
            });
          } else if (EventCordinatorMobileErrMsg) {
            this.setState({
              EventCordinatorMobileErr: "Please Enter proper mobile number",
            });
          } else if (PrimaryContactMobileErrMsg) {
            this.setState({
              PrimaryContactMobileErr: "Please Enter proper mobile number",
            });
          } else if (EventCordinatorEmailErrMsg) {
            this.setState({
              EventCordinatorEmailErr: "Please enter proper email",
            });
          } else if (PrimaryContactEmailErrMsg) {
            this.setState({
              PrimaryContactEmailErr: "Please enter proper email",
            });
          }
        } else if (
          gstErrMsg != "" ||
          tanErrMsg != "" ||
          errMsg2 != "" ||
          errMsg4 != "" ||
          mobile2ErrMsg != "" ||
          SAAMobile2ErrMsg != ""
        ) {
          toast.error(
            gstErrMsg != ""
              ? gstErrMsg
              : tanErrMsg != ""
                ? tanErrMsg
                : errMsg2 != ""
                  ? errMsg2
                  : errMsg4 != ""
                    ? errMsg4
                    : mobile2ErrMsg != ""
                      ? mobile2ErrMsg
                      : SAAMobile2ErrMsg != ""
                        ? SAAMobile2ErrMsg
                        : "",
            {
              position: "top-center",
              theme: "colored",
              autoClose: 1000,
              hideProgressBar: true,
            }
          );
        } else {
          if (
            Mobile1 != EventCordinatorMobile &&
            Mobile1 != PrimaryContactMobile
          ) {
            this.setState({ isLoading: true });
            this.props
              .company_info_add_update_action(
                ClientID,
                OrderID,
                firstName,
                lastName,
                designation,
                companyName,
                addressLine1,
                addressLine2,
                cityId,
                stateId,
                countryId,
                pincode,
                Mobile1,
                Mobile2,
                TelephoneNumber != "" &&
                  TelephoneNumber != null &&
                  preTel != "" &&
                  preTel != null
                  ? preTel + "-" + TelephoneNumber
                  : TelephoneNumber,
                primaryEmailID,
                secondaryEmailID,
                website,
                SameAsAbove,
                SAAFirstName,
                SAALastName,
                SAADesignation,
                SAACompanyName,
                SAAAddressLine1,
                SAAAddressLine2,
                SAACityId,
                SAAStateId,
                SAACountryId,
                SAAPincode,
                SAAMobile1,
                SAAMobile2,
                SAATelephoneNumber != "" &&
                  SAATelephoneNumber != null &&
                  SAAPreTel != "" &&
                  SAAPreTel != null
                  ? SAAPreTel + "-" + SAATelephoneNumber
                  : SAATelephoneNumber,
                SAAPrimaryEmailID,
                SAASecondaryEmailID,
                SAAWebsite,
                registrationNumber,
                PANCardNo,
                NameonPANCard,
                GSTNo,
                companyStatusId,
                TANNumber,
                UINNumber,
                accountName,
                accountNo,
                accountType,
                bankName,
                branchName,
                IFSCCode,
                EventCordinatorName,
                EventCordinatorDesignation,
                EventCordinatorEmail,
                EventCordinatorMobile,
                PrimaryContactName,
                PrimaryContactDesignation,
                PrimaryContactEmail,
                PrimaryContactMobile
              )
              .then((data) => {
                if (data.error != 1) {
                  console.log("data.data", data.data);
                  this.setState({ isLoading: false });
                  this.props.navigate("/normalView");
                } else {
                  this.setState({ isLoading: false });
                  toast.error(data.msg, {
                    position: "top-center",
                    theme: "colored",
                    autoClose: 3000,
                    hideProgressBar: true,
                  });
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            toast.error(
              "Provide Different Contact Number for Event Coordinator!",
              {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
              }
            );
            this.mobileCheckedSameOrNot();
          }
        }
      } else {
        toast.error("Please enter mandatory fields!", {
          position: "top-center",
          theme: "colored",
          autoClose: 1000,
          hideProgressBar: true,
        });
        this.setState({ isLoading: false });
      }
    } else {
      if (
        firstName != "" &&
        firstName != null &&
        lastName != "" &&
        lastName != null &&
        companyName != "" &&
        companyName != null &&
        countryId != "" &&
        countryId != null &&
        countryId != "Country*" &&
        stateId != null &&
        stateId != "" &&
        addressLine1 != "" &&
        addressLine1 != null &&
        cityId != "" &&
        cityId != null &&
        pincode != "" &&
        pincode != null &&
        Mobile1 != "" &&
        Mobile1 != null &&
        primaryEmailID != "" &&
        primaryEmailID != null &&
        SAAFirstName != "" &&
        SAAFirstName != null &&
        SAALastName != "" &&
        SAALastName != null &&
        SAACompanyName != "" &&
        SAACompanyName != null &&
        SAAAddressLine1 != "" &&
        SAAAddressLine1 != null &&
        SAACountryId != "" &&
        SAACountryId != null &&
        SAACountryId != "" &&
        SAACountryId != "Country*" &&
        SAACityId != "" &&
        SAACityId != null &&
        SAAStateId != null &&
        SAAStateId != "" &&
        SAAPincode != "" &&
        SAAPincode != null &&
        SAAMobile1 != "" &&
        SAAMobile1 != null &&
        SAAPrimaryEmailID != "" &&
        SAAPrimaryEmailID != null &&
        companyStatusId != "" &&
        companyStatusId != null &&
        companyStatusId != "Select" &&
        accountName != "" &&
        accountName != null &&
        accountNo != "" &&
        accountNo != null &&
        accountType != "" &&
        accountType != null &&
        accountType != "Select" &&
        accountType != "Account Type*" &&
        bankName != "" &&
        bankName != null &&
        branchName != "" &&
        branchName != null &&
        IFSCCode != "" &&
        IFSCCode != null &&
        EventCordinatorName != "" &&
        EventCordinatorName != null &&
        EventCordinatorDesignation != "" &&
        EventCordinatorDesignation != null &&
        EventCordinatorEmail != "" &&
        EventCordinatorEmail != null &&
        EventCordinatorMobile != "" &&
        EventCordinatorMobile != null &&
        PrimaryContactName != "" &&
        PrimaryContactName != null &&
        PrimaryContactDesignation != "" &&
        PrimaryContactDesignation != null &&
        PrimaryContactEmail != "" &&
        PrimaryContactEmail != null &&
        PrimaryContactMobile != "" &&
        PrimaryContactMobile != null
      ) {
        var errMsg1 = emailValidator(primaryEmailID);
        var errMsg2 = notMendetoryEmailValidator(secondaryEmailID);
        var errMsg3 = emailValidator(SAAPrimaryEmailID);
        var errMsg4 = notMendetoryEmailValidator(SAASecondaryEmailID);
        // var mobile1ErrMsg = mobileNoValidator(Mobile1)
        // var mobile2ErrMsg = notMendetoryMobileNoValidator(Mobile2)
        // var SAAMobile1ErrMsg = mobileNoValidator(SAAMobile1)
        // var SAAMobile2ErrMsg = notMendetoryMobileNoValidator(SAAMobile2)
        // var EventCordinatorMobileErrMsg = mobileNoValidator(EventCordinatorMobile)
        // var PrimaryContactMobileErrMsg = mobileNoValidator(PrimaryContactMobile)
        var EventCordinatorEmailErrMsg = emailValidator(EventCordinatorEmail);
        var PrimaryContactEmailErrMsg = emailValidator(PrimaryContactEmail);
        if (
          errMsg1 != "" ||
          errMsg3 != "" ||
          EventCordinatorEmailErrMsg != "" ||
          PrimaryContactEmailErrMsg != ""
        ) {
          toast.error(
            errMsg1 != ""
              ? errMsg1
              : errMsg3 != ""
                ? errMsg3
                : EventCordinatorEmailErrMsg != ""
                  ? EventCordinatorEmailErrMsg
                  : PrimaryContactEmailErrMsg != ""
                    ? PrimaryContactEmailErrMsg
                    : "",
            {
              position: "top-center",
              theme: "colored",
              autoClose: 1000,
              hideProgressBar: true,
            }
          );

          if (errMsg1) {
            this.setState({ primaryEmailIDErr: "Please enter proper email" });
          } else if (errMsg3) {
            this.setState({
              SAAPrimaryEmailIDErr: "Please enter proper email",
            });
          } else if (mobile1ErrMsg) {
            this.setState({ Mobile1Err: "Please Enter proper mobile number" });
          } else if (SAAMobile1ErrMsg) {
            this.setState({
              SAAMobile1Err: "Please Enter proper mobile number",
            });
          } else if (EventCordinatorMobileErrMsg) {
            this.setState({
              EventCordinatorMobileErr: "Please Enter proper mobile number",
            });
          } else if (PrimaryContactMobileErrMsg) {
            this.setState({
              PrimaryContactMobileErr: "Please Enter proper mobile number",
            });
          } else if (EventCordinatorEmailErrMsg) {
            this.setState({
              EventCordinatorEmailErr: "Please enter proper email",
            });
          } else if (PrimaryContactEmailErrMsg) {
            this.setState({
              PrimaryContactEmailErr: "Please enter proper email",
            });
          }
        } 
        // else if (
        //   errMsg2 != "" ||
        //   errMsg4 != "" ||
        //   mobile2ErrMsg != "" ||
        //   SAAMobile2ErrMsg != ""
        // ) {
        //   toast.error(
        //     errMsg2 != ""
        //       ? errMsg2
        //       : errMsg4 != ""
        //         ? errMsg4
        //         : mobile2ErrMsg != ""
        //           ? mobile2ErrMsg
        //           : SAAMobile2ErrMsg != ""
        //             ? SAAMobile2ErrMsg
        //             : "",
        //     {
        //       position: "top-center",
        //       theme: "colored",
        //       autoClose: 1000,
        //       hideProgressBar: true,
        //     }
        //   );
        // }
         else {
          if (
            Mobile1 != EventCordinatorMobile &&
            Mobile1 != PrimaryContactMobile
          ) {
            this.setState({ isLoading: true });
            this.props
              .company_info_add_update_action(
                ClientID,
                OrderID,
                firstName,
                lastName,
                designation,
                companyName,
                addressLine1,
                addressLine2,
                cityId,
                stateId,
                countryId,
                pincode,
                Mobile1,
                Mobile2,
                TelephoneNumber != '' && TelephoneNumber != null && (AreaCode != '' && preTel != '' ? preTel + '-' + AreaCode + '-' + TelephoneNumber : (preTel != '' ? preTel + '-' + TelephoneNumber : TelephoneNumber)),
                primaryEmailID,
                secondaryEmailID,
                website,
                SameAsAbove,
                SAAFirstName,
                SAALastName,
                SAADesignation,
                SAACompanyName,
                SAAAddressLine1,
                SAAAddressLine2,
                SAACityId,
                SAAStateId,
                SAACountryId,
                SAAPincode,
                SAAMobile1,
                SAAMobile2,
                SAATelephoneNumber != '' && SAATelephoneNumber != null && (SAAAreaCode != '' && SAAPreTel != '' ? SAAPreTel + '-' + SAAAreaCode + '-' + TelephoneNumber : (SAAPreTel != '' ? preTel + '-' + SAATelephoneNumber : SAATelephoneNumber)),
                SAAPrimaryEmailID,
                SAASecondaryEmailID,
                SAAWebsite,
                registrationNumber,
                PANCardNo,
                NameonPANCard,
                GSTNo,
                companyStatusId,
                TANNumber,
                UINNumber,
                accountName,
                accountNo,
                accountType,
                bankName,
                branchName,
                IFSCCode,
                EventCordinatorName,
                EventCordinatorDesignation,
                EventCordinatorEmail,
                EventCordinatorMobile,
                PrimaryContactName,
                PrimaryContactDesignation,
                PrimaryContactEmail,
                PrimaryContactMobile
              )
              .then((data) => {
                if (data.error != 1) {
                  console.log("data.data", data.data);
                  this.setState({ isLoading: false });
                  this.props.navigate("/normalView");
                } else {
                  this.setState({ isLoading: false });
                  toast.error(data.msg, {
                    position: "top-center",
                    theme: "colored",
                    autoClose: 3000,
                    hideProgressBar: true,
                  });
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            toast.error("MobileNo can not be same!", {
              position: "top-center",
              theme: "colored",
              autoClose: 1000,
              hideProgressBar: true,
            });
            this.mobileCheckedSameOrNot();
          }
        }
      } else {
        toast.error("Please enter mandatory fields!", {
          position: "top-center",
          theme: "colored",
          autoClose: 1000,
          hideProgressBar: true,
        });
        this.setState({ isLoading: false });
      }
    }
  }

  onFilePick = async (e, file) => {
    e.preventDefault();
    const {
      formFile,
      trcFile,
      declarationFile,
      formFileType,
      declarationFileType,
      trcFileType,
    } = this.state;
    var image = "";
    console.log("type", file);
    console.log("name", file[0]["name"]);
    if (file[0]["size"] > 5242880) {
      toast.error("File size more than 5MB are not allow.", {
        position: "top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
    } else {
      if (
        file[0]["name"].toString().toLowerCase().includes(".pdf") ||
        file[0]["name"].toString().toLowerCase().includes(".jpeg") ||
        file[0]["name"].toString().toLowerCase().includes(".png") ||
        file[0]["name"].toString().toLowerCase().includes(".jpg")
      ) {
        if (file[0]["name"].includes("pdf")) {
          image = await this.onPdfSelect(file[0]);
        } else {
          image = await this.resizeFile(file[0]);
        }
        sessionStorage.setItem("formFile", image);
        sessionStorage.setItem("fileName", file[0]["name"]);
        sessionStorage.setItem("membershipFilePath", "");
        // console.log("******************fileNAMEMMMMMMMMMMMMMMMMM", file[0]['name'])
        // console.log("setItem('formFile')", image)
        // console.log("setItem('fileName')", file[0]['name'])

        this.setState({
          formFile: image,
          fileName: file[0]["name"],
          is_Update_Membership: true,
        });

        console.log("file type xyz **", file[0]["type"]);
        const fileType = file[0]["type"];
        var fileTypeList;
        if (fileType.includes("/")) {
          fileTypeList = fileType.split("/");
        }
        this.setState({
          formFileType: fileTypeList.length > 0 ? fileTypeList[1] : "",
        });
        sessionStorage.setItem(
          "membershipFormFileType",
          fileTypeList.length > 0 ? fileTypeList[1] : ""
        );
        // console.log("setItem('membershipFormFileType')", fileTypeList[1])
      } else {
        // Only .pdf , .jpeg, .png, .jpg files are allowed
        toast.error("Only .pdf, .jpeg, .png, files are allowed", {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
      }
    }
  };

  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      // FileReader function for read the file.
      let fileReader = new FileReader();
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        resolve(base64);
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    });

  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        "JPEG",
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300
      );
    });

  removeFile() {
    const { checkboxFlag } = this.state;
    this.setState({
      fileName: "",
      formFile: "",
      fileType: "",
    });
    sessionStorage.setItem("formFile", "");
    sessionStorage.setItem("membershipFormFileType", "");
    sessionStorage.setItem("fileName", "");
    sessionStorage.setItem("getDetailsFileName", "");
    sessionStorage.setItem("membershipFilePath", "");
    sessionStorage.setItem("dummyMembershipFlag", "");
  }

  updateMembershipFile(flag) {
    const { formFile, formFileType, fileName } = this.state;
    const OrderID =
      this.props.location.state != null &&
        this.props.location.state.OrderID != null
        ? this.props.location.state.OrderID
        : "";
    // this.setState({ isLoading: true })
    this.props
      .update_membership_file_action(
        OrderID,
        formFile,
        formFileType,
        fileName,
        flag
      )
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false, is_Update_Membership: false });
          if (flag == 0) {
            sessionStorage.removeItem("formFile");
            sessionStorage.removeItem("membershipFormFileType");
            sessionStorage.removeItem("fileName");
            sessionStorage.removeItem("checkboxFlag");
            sessionStorage.removeItem("dummyMembershipFlag");
            this.setState({
              formFile: "",
              formFileType: "",
              fileName: "",
              checkboxFlag: false,
            });
          }
        } else {
          this.setState({ isLoading: false });
          toast.error(data.data, {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  getCompanyInfoDetails() {
    const OrderID =
      this.props.location.state != null &&
        this.props.location.state.OrderID != null
        ? this.props.location.state.OrderID
        : "";
    const ClientID =
      this.props.location.state != null &&
        this.props.location.state.ClientID != null
        ? this.props.location.state.ClientID
        : null;
    this.setState({ isLoading: true });
    const UserId =
      this.props.location.state != null &&
        this.props.location.state.UserID != null
        ? this.props.location.state.UserID
        : parseInt(sessionStorage.getItem("userId"));
    this.props
      .get_company_info_Details_action(ClientID, OrderID, UserId)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          console.log(
            "data.data['data'][0]['FirstName']",
            data.data["data"][0]["FirstName"]
          );
          this.setState({
            firstName: data.data["data"][0]["FirstName"],
            lastName: data.data["data"][0]["LastName"],
            designation: data.data["data"][0]["Designation"],
            companyName: data.data["data"][0]["CompanyName"],
            addressLine1: data.data["data"][0]["AddressLine1"],
            addressLine2: data.data["data"][0]["AddressLine2"],
            cityId: data.data["data"][0]["City"],
            SAACityId: data.data["data"][0]["InvCityName"],
            stateId: data.data["data"][0]["State"],
            countryId: data.data["data"][0]["CountryID"],
            pincode: data.data["data"][0]["Pincode"],
            Mobile1: data.data["data"][0]["Mobile"],
            Mobile2: data.data["data"][0]["Mobile2"],
            primaryEmailID: data.data["data"][0]["PrimaryEmailID"],
            secondaryEmailID: data.data["data"][0]["SecondaryEmailID"],
            website: data.data["data"][0]["Website"],
            SameAsAbove: data.data["data"][0]["IS_SameAsAbove"],
            SAAFirstName: data.data["data"][0]["Inv_FirstName"],
            SAALastName: data.data["data"][0]["Inv_LastName"],
            SAADesignation: data.data["data"][0]["Inv_Designation"],
            SAACompanyName: data.data["data"][0]["Inv_CompanyName"],
            SAAAddressLine1: data.data["data"][0]["Inv_AddressLine1"],
            SAAAddressLine2: data.data["data"][0]["Inv_AddressLine2"],
            SAACityName: data.data["data"][0]["InvCityName"],
            SAAStateId: data.data["data"][0]["InvStateName"],
            SAACountryId: data.data["data"][0]["Inv_CountryID"],
            SAAPincode: data.data["data"][0]["Inv_Pincode"],
            SAAMobile1: data.data["data"][0]["Inv_Mobile1"],
            SAAMobile2: data.data["data"][0]["Inv_Mobile2"],
            SAAPrimaryEmailID: data.data["data"][0]["Inv_PrimaryEmailID"],
            SAASecondaryEmailID: data.data["data"][0]["Inv_SecondaryEmailID"],
            SAAWebsite: data.data["data"][0]["Inv_Website"],
            registrationNumber: data.data["data"][0]["CompanyRegistrationNo"],
            PANCardNo: data.data["data"][0]["PanNo"],
            NameonPANCard: data.data["data"][0]["NameOnPanCard"],
            GSTNo: data.data["data"][0]["GSTNo"],
            companyStatusId: data.data["data"][0]["CompanyStatusID"],
            TANNumber: data.data["data"][0]["TanNo"],
            UINNumber: data.data["data"][0]["UINNo"],
            ClientID: data.data["data"][0]["ClientID"],
            accountName: data.data["data"][0]["AccountName"],
            accountNo: data.data["data"][0]["AccountNo"],
            accountType: data.data["data"][0]["AccountType"],
            bankName: data.data["data"][0]["BankName"],
            branchName: data.data["data"][0]["BranchName"],
            IFSCCode: data.data["data"][0]["IFSCCode"],
            EventCordinatorName: data.data["data"][0]["EventCordinatorName"],
            EventCordinatorDesignation:
              data.data["data"][0]["EventCordinatorDesignation"],
            EventCordinatorEmail: data.data["data"][0]["EventCordinatorEmail"],
            EventCordinatorMobile:
              data.data["data"][0]["EventCordinatorMobile"],
            PrimaryContactName: data.data["data"][0]["PrimaryContactName"],
            PrimaryContactDesignation:
              data.data["data"][0]["PrimaryContactDesignation"],
            PrimaryContactEmail: data.data["data"][0]["PrimaryContactEmail"],
            PrimaryContactMobile: data.data["data"][0]["PrimaryContactMobile"],

            dummyFileName:
              data.data["membershipFilePath"] != "" &&
                data.data["membershipFilePath"][0]["MembershipFilePath"] != null
                ? data.data["membershipFilePath"][0][
                  "MembershipFilePath"
                ].split(`/document/membership/${OrderID}/`)
                : null,
          });

          if (data.data['data'][0]['Telephone'] != null && data.data['data'][0]['Telephone'].includes('-')) {
            const concateData = data.data['data'][0]['Telephone'].split('-')
            this.setState({ preTel: concateData[0], AreaCode: concateData[1], TelephoneNumber: concateData[2] })
          } else {
            this.setState({ TelephoneNumber: data.data['data'][0]['Telephone'] })
          }

          if (data.data['data'][0]['Inv_Telephone'] != null && data.data['data'][0]['Inv_Telephone'].includes('-')) {
            const concateData = data.data['data'][0]['Inv_Telephone'].split('-')
            this.setState({ SAAPreTel: concateData[0], SAAAreaCode: concateData[1], SAATelephoneNumber: concateData[2] })
          } else {
            this.setState({ SAATelephoneNumber: data.data['data'][0]['Inv_Telephone'] })
          }

          if (
            sessionStorage.getItem("formFile") == null &&
            sessionStorage.getItem("membershipFormFileType") == null &&
            sessionStorage.getItem("fileName") == null
          ) {
            if (data.data["membershipFilePath"].length > 0) {
              sessionStorage.setItem(
                "membershipFilePath",
                data.data["membershipFilePath"][0]["MembershipFilePath"]
              );
              this.setState({
                memershipFilePath:
                  data.data["membershipFilePath"][0]["MembershipFilePath"],
              });
              this.setState({
                checkboxFlag:
                  data.data["membershipFilePath"][0]["Is_Membership"],
              });
            }
          }

          const { countryList, countryId } = this.state;

          console.log("countryList-------------------");
          setTimeout(() => {
            countryList.map((itme) => {
              if (itme.Countryid == data.data["data"][0]["CountryID"]) {
                this.setState({ ISD: itme.ExtensionCode });
              }
            });
          }, 10);

          setTimeout(() => {
            countryList.map((itme) => {
              if (itme.Countryid == data.data["data"][0]["Inv_CountryID"]) {
                this.setState({ SAAISD: itme.ExtensionCode });
              }
            });
          }, 10);

          setTimeout(() => {
            const { dummyFileName, fileName } = this.state;
            // console.log("******************************fileName123@@@@,",sessionStorage.getItem('fileName'))
            // console.log("******************************membershipFilePath@@@@,", sessionStorage.getItem('membershipFilePath'))
            if (
              sessionStorage.getItem("membershipFilePath") != "" &&
              sessionStorage.getItem("membershipFilePath") != null &&
              sessionStorage.getItem("checkboxFlag") == null &&
              data.data["membershipFilePath"] != ""
            ) {
              if (
                data.data["membershipFilePath"][0]["MembershipFilePath"] != null
              ) {
                var array = [];
                array.push(dummyFileName);
                var dummyArray = array[0][1].split(".");
                this.setState({
                  fileName: dummyArray[0] + "." + dummyArray[1],
                  checkboxFlag:
                    data.data["membershipFilePath"][0]["Is_Membership"],
                });
              }
            }
          }, 100);
        } else {
          this.setState({ isLoading: false });
          toast.error(data.data, {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  vendorDetails() {
    const { ExternalServicesList, ExternalServicesListTable,VendorID } = this.state;

    this.setState({ isLoading: true });
    this.props
      .vendor_detail_action(VendorID)
      .then((data) => {
        console.log("Vendor details--------", data);
        if (data.error != 1) {
          this.setState({ isLoading: false });

          const updatedServicePackageList = data.data[2].map((slData) => {
            return {
              ServiceID: slData.ServiceID,
              City: slData.City,
              Package: slData.Package,
              PackageDetails: slData.PackageDetails,
              // Price_In_INR: slData.Price_In_INR,
              // Price_In_USD: slData.Price_In_USD,
              // ITME_CutOff_Limit: slData.ITME_CutOff_Limit,
              ITME_Margin: slData.ITME_Margin,
              previewImagesInput: [],
            };
          });
          console.log("updatedPriceList", updatedServicePackageList);
          this.setState({
            servicePackageList: updatedServicePackageList,
            VendorID: data.data[0][0]["VendorID"],
            password: data.data[0][0]["Password"],
            confPassword: data.data[0][0]["Password"],
            firstName: data.data[0][0]["FirstName"],
            lastName: data.data[0][0]["LastName"],
            designation: data.data[0][0]["Designation"],
            companyName: data.data[0][0]["CompanyName"],
            addressLine1: data.data[0][0]["AddressLine1"],
            addressLine2: data.data[0][0]["AddressLine2"],
            cityId: data.data[0][0]["City"],
            stateId: data.data[0][0]["State"],
            countryId: data.data[0][0]["CountryID"],
            pincode: data.data[0][0]["Pincode"],
            Mobile1: data.data[0][0]["Mobile1"],
            Mobile2: data.data[0][0]["Mobile2"],
            TelephoneNumber: data.data[0][0]["Telephone"],
            primaryEmailID: data.data[0][0]["PrimaryEmailID"],
            secondaryEmailID: data.data[0][0]["SecondaryEmailID"],
            website: data.data[0][0]["Website"],
            registrationNumber: data.data[0][0]["CompanyRegistrationNo"],
            PANCardNo: data.data[0][0]["PanNo"],
            NameonPANCard: data.data[0][0]["NameOnPanCard"],
            GSTNo: data.data[0][0]["GSTNo"],
            TANNumber: data.data[0][0]["TanNo"],
            UINNumber: data.data[0][0]["UINNo"],
            VendorID: data.data[0][0]["VendorID"],
            accountName: data.data[0][0]["AccountName"],
            accountNo: data.data[0][0]["AccountNo"],
            accountType: data.data[0][0]["AccountType"],
            bankName: data.data[0][0]["BankName"],
            branchName: data.data[0][0]["BranchName"],
            IFSCCode: data.data[0][0]["IFSCCode"],
          });
          const operateServicesGetList = data.data[1];
          if (operateServicesGetList != null) {
            const getservicesIdArray = [];
            const newServiceArray = [];
            getservicesIdArray.push(operateServicesGetList);
            getservicesIdArray[0].forEach((data) => {
              newServiceArray.push({
                value: data.ServiceID,
                label: data.ServiceName,
              });
            });

            this.setState({
              ExternalServicesListTable: newServiceArray,
              vendorServiceList: data.data[1],
              VendorServiceID: data.data[1]["VendorServiceID"],
              ServiceID: data.data[1]["ServiceID"],
              ServiceName: data.data[1]["ServiceName"],
              materialList: data.data[4],
            });
            console.log(
              "newEventArray",
              ExternalServicesListTable,
              data.data[4]
            );
          }
          const { countryList, countryId } = this.state;

          setTimeout(() => {
            countryList.map((itme) => {
              if (itme.Countryid == data.data[0]["CountryID"]) {
                this.setState({ ISD: itme.ExtensionCode });
              }
            });
          }, 200);
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  onCountryId(e) {
    const { countryList, countryId, SameAsAbove, ISD } = this.state;
    this.setState({ countryId: e.target.value, countryIdErr: "" });

    countryList.map((data) => {
      if (data.Countryid == e.target.value) {
        console.log("************* e target value 1234", data.ExtensionCode);
        this.setState({ ISD: data.ExtensionCode });
        if (SameAsAbove) {
          this.setState({ SAAISD: data.ExtensionCode });
        }
      }
    });

    setTimeout(() => {
      if (SameAsAbove) {
        this.setState({
          SAACountryId: e.target.value,
          SAACountryIdErr: "",
        });
        if (e.target.value != 91) {
          this.setState({
            SAAPincode: "",
            SAACityId: "",
            SAAStateId: "",
            SAAAddressLine1: "",
            SAAAddressLine2: "",
          });
        }
      }
    }, 100);

    if (e.target.value == "91") {
      this.getFillList(stateActionId, "", e.target.value, "");
      this.getFillList(cityActionId, "", e.target.value, "");
    } else {
      this.setState({
        PANCardNo: "",
        PANCardNoErr: "",
        TANNumber: "",
        UINNumber: "",
        GSTNo: "",
        registrationNumber: "",
        NameonPANCard: "",
        NameonPANCardErr: "",
        PANCardNoErr: "",
        NameonPANCardErr: "",
        accountName: "",
        accountNo: "",
        accountType: "",
        bankName: "",
        branchName: "",
        IFSCCode: "",
        accountNameErr: "",
        accountNoErr: "",
        accountTypeErr: "",
        bankNameErr: "",
        branchNameErr: "",
        IFSCCodeErr: "",
      });
    }

    if (e.target.value != 91) {
      this.setState({
        cityId: "",
        stateId: "",
        pincode: "",
        isDisplayStateList: false,
        isDisplayCityList: false,
        addressLine1: "",
        addressLine2: "",
        CityNameErr: "",
        stateErr: "",
        pincodeErr: "",
      });
    } else {
      this.setState({
        CityNameErr: "",
        stateErr: "",
        pincodeErr: "",
      });
    }
  }

  onSAACountryId(e) {
    const { countryList, SAACountryId } = this.state;
    this.setState({ SAACountryId: e.target.value, SAACountryIdErr: "" });
    if (e.target.value != "") {
      countryList.map((data) => {
        if (data.Countryid == e.target.value) {
          console.log("************* e target value", e.target.value);
          setTimeout(() => {
            this.setState({ SAAISD: data.ExtensionCode });
          }, 100);
        } else {
          this.setState({
            SAAISD: "",
          });
        }
      });
    }
    if (e.target.value == "91") {
      this.getFillList(stateActionId, "", e.target.value, "");
      this.getFillList(cityActionId, "", e.target.value, "");
    }
    if (e.target.value != 91) {
      this.setState({
        SAACityId: "",
        SAAStateId: "",
        SAAPincode: "",
        SAAAddressLine1: "",
        SAAAddressLine2: "",
        isSAADisplayStateList: false,
        isSAADisplayCityList: false,
        SAACityNameErr: "",
        SAAStateErr: "",
        SAAPincodeErr: "",
      });
    } else {
      this.setState({
        SAACityNameErr: "",
        SAAStateErr: "",
        SAAPincodeErr: "",
      });
    }
  }

  calenderView(flag) {
    const { OrderID, CenterID, LastDate, is_Update_Membership } = this.state;
    console.log("LastDate", LastDate);
    const ClientID =
      this.props.location.state != null &&
        this.props.location.state.ClientID != null
        ? this.props.location.state.ClientID
        : "";
    const isEdit =
      this.props.location.state != null &&
        this.props.location.state.isEdit != null
        ? this.props.location.state.isEdit
        : null;

    this.props.navigate("/calenderView", {
      state: {
        OrderID: OrderID,
        centerID: CenterID != "" ? CenterID : null,
        ClientID: ClientID,
        LastDate: LastDate != "" ? LastDate : null,
        isEdit: isEdit,
      },
    });

    if (flag == 1) {
      if (is_Update_Membership) {
        this.updateMembershipFile(1);
      }
    }
  }

  checkbox(e) {
    this.setState(
      (prevState) => ({
        checkboxFlag: !prevState.checkboxFlag,
      }),
      () => {
        // Callback function after state is updated
        console.log("Checkbox state:", this.state.checkboxFlag);
        sessionStorage.setItem(
          "checkboxFlag",
          this.state.checkboxFlag.toString()
        );

        if (!this.state.checkboxFlag) {
          // If checkbox is unchecked
          this.setState({
            fileName: "",
            formFile: "",
            fileType: "",
          });
          sessionStorage.removeItem("formFile");
          sessionStorage.removeItem("membershipFormFileType");
          sessionStorage.removeItem("fileName");
          if (
            this.props.location.state != null &&
            this.props.location.state.OrderID != null
          ) {
            this.updateMembershipFile(0);
          }
        }
      }
    );
  }

  chooseCompanyStatus(e) {
    this.setState({ companyStatusId: e.target.value, companyStatusErr: "" });
  }

  firstName(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      firstName: e.target.value
        .replace(/[^a-zA-Z\s]/g, "")
        .replace(/\s+/g, " ")
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      firstNameErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAFirstName: e.target.value
          .replace(/[^a-zA-Z\s]/g, "")
          .replace(/\s+/g, " ")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAAFirstNameErr: "",
      });
    }
  }

  lastName(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      lastName: e.target.value
        .replace(/[^a-zA-Z\s]/g, "")
        .replace(/\s+/g, " ")
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      lastNameErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAALastName: e.target.value
          .replace(/[^a-zA-Z\s]/g, "")
          .replace(/\s+/g, " ")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAALastNameErr: "",
      });
    }
  }

  designation(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      designation: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
    });
    if (SameAsAbove) {
      this.setState({
        SAADesignation: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
      });
    }
  }

  organizerName(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      companyName: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      organizerErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAACompanyName: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAACompanyNameErr: "",
      });
    }
  }

  addressLine1(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      addressLine1: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      addressLine1Err: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAAddressLine1: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAAAddressLine1Err: "",
      });
    }
  }

  addressLine2(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      addressLine2: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
    });
    if (SameAsAbove) {
      this.setState({
        SAAAddressLine2: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
      });
    }
  }

  pincode(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      pincode: e.target.value.replace(/\D/, ""),
      pincodeErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAPincode: e.target.value.replace(/\D/, ""),
        SAAPincodeErr: "",
      });
    }
  }

  mobile1(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      Mobile1: e.target.value.replace(/\D/, ""),
      Mobile1Err: "",
    });
    if (SameAsAbove) {
      this.setState({ SAAMobile1: e.target.value, SAAMobile1Err: "" });
    }
  }

  mobile2(e) {
    const { SameAsAbove } = this.state;
    this.setState({ Mobile2: e.target.value.replace(/\D/, "") });
    if (SameAsAbove) {
      this.setState({ SAAMobile2: e.target.value });
    }
  }

  telephone(e) {
    const { SameAsAbove } = this.state;
    this.setState({ TelephoneNumber: e.target.value.replace(/\D/, "") });
    if (SameAsAbove) {
      this.setState({ SAATelephoneNumber: e.target.value });
    }
  }

  primaryEmail(e) {
    const { SameAsAbove } = this.state;
    this.setState({ primaryEmailID: e.target.value, primaryEmailIDErr: "" });
    if (SameAsAbove) {
      this.setState({
        SAAPrimaryEmailID: e.target.value,
        SAAPrimaryEmailIDErr: "",
      });
    }
  }

  secondaryEmail(e) {
    const { SameAsAbove } = this.state;
    this.setState({ secondaryEmailID: e.target.value });
    if (SameAsAbove) {
      this.setState({ SAASecondaryEmailID: e.target.value });
    }
  }

  website(e) {
    const { SameAsAbove } = this.state;
    this.setState({ website: e.target.value });
    if (SameAsAbove) {
      this.setState({ SAAWebsite: e.target.value });
    }
  }

  preTelephone(e) {
    const { SameAsAbove } = this.state;
    this.setState({ preTel: e.target.value });
    if (SameAsAbove) {
      this.setState({ SAAPreTel: e.target.value });
    }
  }

  areaCode(e) {
    const { SameAsAbove } = this.state
    this.setState({ AreaCode: e.target.value })
    if (SameAsAbove) {
      this.setState({ SAAAreaCode: e.target.value })
    }
  }

  CompanyEditFalse() {
    this.setState({ isEditMode: true });
  }

  CompanyEditTrue() {
    this.setState({ isEditMode: false });
  }

  render() {
    const {
      isLoading,
      showDetails,materialList,
      showImg,
      showPackageDetails,
      stateId,
      stateList,
      countryId,
      countryList,
      firstName,
      lastName,
      designation,
      companyName,
      addressLine1,
      addressLine2,
      cityId,
      cityList,
      pincode,
      Mobile1,
      Mobile2,
      ISD,
      primaryEmailID,
      secondaryEmailID,
      website,
      SameAsAbove,
      SAAFirstName,
      SAALastName,
      SAADesignation,
      SAAAddressLine1,
      SAAAddressLine2,
      SAACityId,
      SAAPincode,
      SAAMobile1,
      SAAMobile2,
      SAAISD,
      SAASTD,
      SAAPrimaryEmailID,
      SAASecondaryEmailID,
      SAAWebsite,
      SAAStateId,
      registrationNumber,
      PANCardNo,
      NameonPANCard,
      GSTNo,
      CompanyStatus,
      TANNumber,
      UINNumber,
      SAATelephoneNumber,
      TelephoneNumber,
      SAACountryId,
      mobileISD1,
      mobileISD2,
      SAAMobileISD1,
      SAAMobileISD2,
      isDisplayCityList,
      CityName,
      SAACityName,
      companyStatusId,
      companyStatusList,
      CenterID,
      accountName,
      accountNo,
      accountType,
      bankName,
      branchName,
      IFSCCode,
      accountTypeList,
      formFile,
      formFileType,
      fileName,
      memershipFilePath,
      checkboxFlag,
      checked,
      SAACompanyName,
      companyStatusErr,
      firstNameErr,
      lastNameErr,
      organizerErr,
      addressLine1Err,
      CityNameErr,
      countryIdErr,
      pincodeErr,
      Mobile1Err,
      primaryEmailIDErr,
      SAAFirstNameErr,
      SAALastNameErr,
      SAAAddressLine1Err,
      SAACityNameErr,
      SAACountryIdErr,
      SAAPincodeErr,
      SAAMobile1Err,
      SAAPrimaryEmailIDErr,
      PANCardNoErr,
      NameonPANCardErr,
      accountNameErr,
      accountNoErr,
      accountTypeErr,
      bankNameErr,
      branchNameErr,
      IFSCCodeErr,
      SAACompanyNameErr,
      stateErr,
      SAAStateErr,
      isSAADisplayCityList,
      isDisplayStateList,
      isSAADisplayStateList,
      preTel,
      SAAPreTel,
      downloadUrl,
      is_Update_Membership,
      EventCordinatorName,
      EventCordinatorDesignation,
      EventCordinatorEmail,
      EventCordinatorMobile,
      PrimaryContactName,
      PrimaryContactDesignation,
      PrimaryContactEmail,
      PrimaryContactMobile,
      EventCordinatorNameErr,
      EventCordinatorDesignationErr,
      EventCordinatorEmailErr,
      EventCordinatorMobileErr,
      PrimaryContactNameErr,
      PrimaryContactDesignationErr,
      PrimaryContactEmailErr,
      PrimaryContactMobileErr,
      isEditMode,
      isVendorLogin,
      TypeOfEventList,
      EventName,
      editedRowIndexServicePackage,
      editedRowServicePackage,
      servicePackageDetails,
      servicePackageList,
      ServiceID,
      City,
      Package,
      PackageDetails,
      Images,
      Price_In_INR,
      Price_In_USD,
      ITME_CutOff_Limit,
      ITME_Margin,
      password,
      confPassword,
      passwordErr,
      confPasswordErr,
      ExternalServices,
      ExternalServicesID,
      ExternalServicesList,
      ExternalServicesListTable,
      editIndex,
      servicePhotoList,
      previewImagesInput,
      VendorID,
      AreaCode,
      SAAAreaCode
    } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[]} />
            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header row">
                  <div class="col-10">
                    {" "}
                    <h4 className="page-title">My Profile</h4>
                  </div>
                  <div class="col-2">
                    {isVendorLogin == true ? (
                      <></>
                    ) : isEditMode == true ? (
                      <a
                        href="javascript:void(0);"
                        onClick={() => this.CompanyEditTrue()}
                        className="btn btn-success"
                      >
                        Edit
                      </a>
                    ) : (
                      <a
                        href="javascript:void(0);"
                        onClick={() => this.CompanyEditFalse()}
                        className="btn btn-warning mx-2"
                      >
                        View
                      </a>
                    )}
                  </div>
                </div>
                <div aria-labelledby="headingOne">
                  <div className="panel-body">
                    <div className="card-body">
                      <div class="company_info">
                        <fieldset>
                          {isVendorLogin ? (
                            <legend>Name and Address of the Vendor</legend>
                          ) : (
                            <legend>
                              Name and Address of the Organizer / Organization
                            </legend>
                          )}

                          <div class="outside_input_field ">
                            {isVendorLogin ? null : (
                              <div class="row">
                                <div class="col-md-4">
                                  <div class="form-group floating-group floating-diff">
                                    <label>
                                      Category
                                      <span className="mendatory_class">*</span>
                                    </label>
                                    <select
                                      id="state"
                                      name="Entry Type"
                                      class="form-control floating-control"
                                      value={companyStatusId}
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      disabled={isEditMode}
                                      onChange={(e) =>
                                        this.chooseCompanyStatus(e)
                                      }
                                    >
                                      <option>Select</option>
                                      {companyStatusList.length > 0 &&
                                        companyStatusList.map((item) => (
                                          <option
                                            key={item.CompanyStatusID}
                                            value={item.CompanyStatusID}
                                          >
                                            {item.Name}
                                          </option>
                                        ))}
                                    </select>
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {companyStatusErr}
                                      </span>
                                    }
                                  </div>
                                </div>
                              </div>
                            )}
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={firstName}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      disabled={isEditMode}
                                      maxLength={30}
                                      onChange={(e) => this.firstName(e)}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {firstNameErr}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      First Name{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={lastName}
                                      type="text"
                                      class="outside"
                                      required
                                      maxLength={30}
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      disabled={isEditMode}
                                      onChange={(e) => this.lastName(e)}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {lastNameErr}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      Last Name{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={designation}
                                      type="text"
                                      class="outside"
                                      required
                                      maxLength={50}
                                      disabled={isEditMode}
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) => this.designation(e)}
                                    />
                                    <span class="floating-label-outside">
                                      Designation
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={companyName}
                                      type="text"
                                      class="outside"
                                      required
                                      maxLength={100}
                                      disabled={isEditMode}
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) => this.organizerName(e)}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {organizerErr}
                                      </span>
                                    }
                                    {isVendorLogin ? (
                                      <>
                                        <span class="floating-label-outside">
                                          Vendor Name{" "}
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <span class="floating-label-outside">
                                          Organizer / Organization Name{" "}
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group floating-group floating-diff">
                                  <label class="floating-label">COUNTRY </label>
                                  <select
                                    id="state"
                                    name="Entry Type"
                                    class="form-control floating-control"
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    value={countryId}
                                    disabled={isEditMode}
                                    onChange={(e) => this.onCountryId(e)}
                                  >
                                    <option value="">
                                      Country
                                      <span class="mendatory_class">*</span>
                                    </option>
                                    {countryList.length > 0 &&
                                      countryList.map((item) => (
                                        <option
                                          key={item.Countryid}
                                          value={item.Countryid}
                                        >
                                          {item.CountryName}
                                        </option>
                                      ))}
                                  </select>
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {countryIdErr}
                                    </span>
                                  }
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={stateId}
                                      type="text"
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      class="outside"
                                      required
                                      onChange={(e) => this.onStateSearch(e)}
                                      autocomplete="off"
                                      maxLength={30}
                                      disabled={isEditMode}
                                    />
                                    {isDisplayStateList &&
                                      this.renderStateList()}
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {stateErr}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      State{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={cityId}
                                      type="text"
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      class="outside"
                                      required
                                      onChange={(e) => this.onCitytSearch(e)}
                                      autocomplete="off"
                                      maxLength={30}
                                      disabled={isEditMode}
                                    />
                                    {isDisplayCityList && this.renderCityList()}
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {CityNameErr}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      City{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={addressLine1}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) => this.addressLine1(e)}
                                      maxLength={100}
                                      disabled={isEditMode}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {addressLine1Err}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      Address Line 1{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={addressLine2}
                                      type="text"
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      class="outside"
                                      required
                                      onChange={(e) => this.addressLine2(e)}
                                      maxLength={100}
                                      disabled={isEditMode}
                                    />
                                    <span class="floating-label-outside">
                                      Address Line 2
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={pincode}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) => this.pincode(e)}
                                      disabled={isEditMode}
                                      maxLength={
                                        countryId == "91" ||
                                          countryId == "" ||
                                          countryId == "Country*"
                                          ? 6
                                          : 35
                                      }
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {pincodeErr}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      {countryId == "91" ||
                                        countryId == "" ||
                                        countryId == "Country*"
                                        ? "Pincode"
                                        : "ZipCode"}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="tel_number">
                                    <div class="ISD">
                                      <input
                                        type="text"
                                        class="outside"
                                        placeholder="ISD"
                                        required
                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                        value={ISD}
                                        disabled={true}
                                      />
                                    </div>
                                    <div class="position-relative width_80">
                                      <input
                                        value={Mobile1}
                                        type="text"
                                        class="outside"
                                        required
                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                        onChange={(e) => this.mobile1(e)}
                                        disabled={isEditMode}
                                        maxLength={countryId == "91" ? 10 : 11}
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {Mobile1Err}
                                        </span>
                                      }
                                      <span class="floating-label-outside">
                                        Mobile 1{" "}
                                        <span class="mendatory_class">*</span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="tel_number">
                                    <div class="ISD">
                                      <input
                                        type="text"
                                        class="outside"
                                        placeholder="ISD"
                                        required
                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                        value={ISD}
                                        disabled={true}
                                      />
                                    </div>
                                    <div class="position-relative width_80">
                                      <input
                                        value={Mobile2}
                                        type="text"
                                        class="outside"
                                        required
                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                        onChange={(e) => this.mobile2(e)}
                                        disabled={isEditMode}
                                        maxLength={countryId == "91" ? 10 : 11}
                                      />
                                      <span class="floating-label-outside">
                                        Mobile 2
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="tel_number">
                                    <div class="ISD">
                                      <input type="text" class="outside" placeholder={countryId == '91' || countryId == '' || countryId == 'Country*' ? 'STD' : 'ISD'}
                                        value={preTel} required
                                        onChange={(e) => this.preTelephone(e)}
                                        maxLength={5}
                                        disabled={isEditMode}
                                      />
                                    </div>
                                    {countryId != '91' && countryId != '' && countryId != 'Country*' ?
                                      <div class="ISD">
                                        <input type="text" class="outside" placeholder="CODE" value={AreaCode} required
                                          onChange={(e) => this.areaCode(e)}
                                          maxLength={10}
                                          disabled={isEditMode}
                                        />
                                      </div>
                                      : <></>}
                                    <div class="position-relative width_80">
                                      <input type="text" class="outside" value={TelephoneNumber} required
                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                        onChange={(e) => this.telephone(e)}
                                        maxLength={16}
                                        disabled={isEditMode}
                                      />
                                      <span class="floating-label-outside">Telephone Number</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={primaryEmailID}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) => this.primaryEmail(e)}
                                      maxLength={100}
                                      disabled={isEditMode}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {primaryEmailIDErr}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      Primary Email ID{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={secondaryEmailID}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) => this.secondaryEmail(e)}
                                      maxLength={100}
                                      disabled={isEditMode}
                                    />
                                    <span class="floating-label-outside">
                                      Secondary Email ID{" "}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={website}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) => this.website(e)}
                                      maxLength={40}
                                      disabled={isEditMode}
                                    />
                                    <span class="floating-label-outside">
                                      Website{" "}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </fieldset>
                        {isVendorLogin ? null : (
                          <>
                            <fieldset>
                              <legend>Event Coordinator details </legend>

                              <div class="outside_input_field ">
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={EventCordinatorName}
                                          type="text"
                                          class="outside"
                                          required
                                          // onKeyDown={(e) => this.handleKeyDown(e)}
                                          maxLength={30}
                                          onChange={(e) =>
                                            this.setState({
                                              EventCordinatorName:
                                                e.target.value
                                                  .replace(/[^a-zA-Z\s]/g, "")
                                                  .replace(/\s+/g, " ")
                                                  .split(" ")
                                                  .map(
                                                    (word) =>
                                                      word
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                      word.slice(1)
                                                  )
                                                  .join(" "),
                                              EventCordinatorNameErr: "",
                                            })
                                          }
                                          disabled={isEditMode}
                                        />
                                        {
                                          <span className="text-danger text-start text-left d-block mt-1">
                                            {EventCordinatorNameErr}
                                          </span>
                                        }
                                        <span class="floating-label-outside">
                                          {" "}
                                          Name{" "}
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={EventCordinatorDesignation}
                                          type="text"
                                          class="outside"
                                          required
                                          maxLength={30}
                                          // onKeyDown={(e) => this.handleKeyDown(e)}
                                          onChange={(e) =>
                                            this.setState({
                                              EventCordinatorDesignation:
                                                e.target.value
                                                  .split(" ")
                                                  .map(
                                                    (word) =>
                                                      word
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                      word.slice(1)
                                                  )
                                                  .join(" "),
                                              EventCordinatorDesignationErr: "",
                                            })
                                          }
                                          disabled={isEditMode}
                                        />
                                        {
                                          <span className="text-danger text-start text-left d-block mt-1">
                                            {EventCordinatorDesignationErr}
                                          </span>
                                        }
                                        <span class="floating-label-outside">
                                          Designation
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={EventCordinatorEmail}
                                          type="text"
                                          class="outside"
                                          required
                                          maxLength={100}
                                          onChange={(e) =>
                                            this.setState({
                                              EventCordinatorEmail:
                                                e.target.value,
                                              EventCordinatorEmailErr: "",
                                            })
                                          }
                                          disabled={isEditMode}
                                        />
                                        {
                                          <span className="text-danger text-start text-left d-block mt-1">
                                            {EventCordinatorEmailErr}
                                          </span>
                                        }
                                        <span class="floating-label-outside">
                                          Email
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="tel_number">
                                        <div class="ISD">
                                          <input
                                            type="text"
                                            class="outside"
                                            placeholder={
                                              countryId == "91" ||
                                                countryId == "" ||
                                                countryId == "Country*"
                                                ? "STD"
                                                : "ISD"
                                            }
                                            required
                                            value={ISD}
                                            disabled={true}
                                          />
                                        </div>
                                        <div class="position-relative width_80">
                                          <input
                                            value={EventCordinatorMobile}
                                            type="text"
                                            class="outside"
                                            required
                                            maxLength={
                                              countryId == "91" ? 10 : 11
                                            }
                                            onChange={(e) =>
                                              this.setState({
                                                EventCordinatorMobile:
                                                  e.target.value.replace(
                                                    /\D/,
                                                    ""
                                                  ),
                                                EventCordinatorMobileErr: "",
                                              })
                                            }
                                            disabled={isEditMode}
                                          />
                                          {
                                            <span className="text-danger text-start text-left d-block mt-1">
                                              {EventCordinatorMobileErr}
                                            </span>
                                          }
                                          <span class="floating-label-outside">
                                            Mobile
                                            <span class="mendatory_class">
                                              *
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </fieldset>

                            <fieldset>
                              <legend>Primary Contact details </legend>

                              <div class="outside_input_field ">
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={PrimaryContactName}
                                          type="text"
                                          class="outside"
                                          required
                                          // onKeyDown={(e) => this.handleKeyDown(e)}
                                          maxLength={30}
                                          onChange={(e) =>
                                            this.setState({
                                              PrimaryContactName: e.target.value
                                                .replace(/[^a-zA-Z\s]/g, "")
                                                .replace(/\s+/g, " ")
                                                .split(" ")
                                                .map(
                                                  (word) =>
                                                    word
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    word.slice(1)
                                                )
                                                .join(" "),
                                              PrimaryContactNameErr: "",
                                            })
                                          }
                                          disabled={isEditMode}
                                        />
                                        {
                                          <span className="text-danger text-start text-left d-block mt-1">
                                            {PrimaryContactNameErr}
                                          </span>
                                        }
                                        <span class="floating-label-outside">
                                          {" "}
                                          Name{" "}
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={PrimaryContactDesignation}
                                          type="text"
                                          class="outside"
                                          required
                                          maxLength={30}
                                          // onKeyDown={(e) => this.handleKeyDown(e)}
                                          onChange={(e) =>
                                            this.setState({
                                              PrimaryContactDesignation:
                                                e.target.value
                                                  .split(" ")
                                                  .map(
                                                    (word) =>
                                                      word
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                      word.slice(1)
                                                  )
                                                  .join(" "),
                                              PrimaryContactDesignationErr: "",
                                            })
                                          }
                                          disabled={isEditMode}
                                        />
                                        {
                                          <span className="text-danger text-start text-left d-block mt-1">
                                            {PrimaryContactDesignationErr}
                                          </span>
                                        }
                                        <span class="floating-label-outside">
                                          Designation
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={PrimaryContactEmail}
                                          type="text"
                                          class="outside"
                                          required
                                          maxLength={100}
                                          onChange={(e) =>
                                            this.setState({
                                              PrimaryContactEmail:
                                                e.target.value,
                                              PrimaryContactEmailErr: "",
                                            })
                                          }
                                          disabled={isEditMode}
                                        />
                                        {
                                          <span className="text-danger text-start text-left d-block mt-1">
                                            {PrimaryContactEmailErr}
                                          </span>
                                        }
                                        <span class="floating-label-outside">
                                          Email
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="tel_number">
                                        <div class="ISD">
                                          <input
                                            type="text"
                                            class="outside"
                                            placeholder={
                                              countryId == "91" ||
                                                countryId == "" ||
                                                countryId == "Country*"
                                                ? "STD"
                                                : "ISD"
                                            }
                                            required
                                            value={ISD}
                                            disabled={true}
                                          />
                                        </div>
                                        <div class="position-relative width_80">
                                          <input
                                            value={PrimaryContactMobile}
                                            type="text"
                                            class="outside"
                                            required
                                            maxLength={
                                              countryId == "91" ? 10 : 11
                                            }
                                            onChange={(e) =>
                                              this.setState({
                                                PrimaryContactMobile:
                                                  e.target.value.replace(
                                                    /\D/,
                                                    ""
                                                  ),
                                                PrimaryContactMobileErr: "",
                                              })
                                            }
                                            disabled={isEditMode}
                                          />
                                          {
                                            <span className="text-danger text-start text-left d-block mt-1">
                                              {PrimaryContactMobileErr}
                                            </span>
                                          }
                                          <span class="floating-label-outside">
                                            Mobile
                                            <span class="mendatory_class">
                                              *
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </fieldset>

                            <fieldset
                              class={SameAsAbove ? "saveAsAbove_section" : ""}
                            >
                              <legend>Billing Address</legend>

                              <div class="mb-2">
                                <div class="bg">
                                  <div class="chiller_cb">
                                    <input
                                      value={SameAsAbove}
                                      id="SameAsAbove"
                                      type="checkbox"
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      selected={SameAsAbove}
                                      checked={SameAsAbove}
                                      onClick={(e) => this.SameAsAbove(e)}
                                      placeholder=""
                                      disabled={isEditMode}
                                    />
                                    <label
                                      for="SameAsAbove"
                                      style={{ color: "#979797" }}
                                    >
                                      Same As Above
                                    </label>
                                    <span></span>
                                  </div>
                                </div>
                              </div>

                              <div class="outside_input_field">
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={SAAFirstName}
                                          type="text"
                                          class="outside"
                                          required
                                          onChange={(e) =>
                                            this.setState({
                                              SAAFirstName: e.target.value
                                                .replace(/[^a-zA-Z\s]/g, "")
                                                .replace(/\s+/g, " ")
                                                .split(" ")
                                                .map(
                                                  (word) =>
                                                    word
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    word.slice(1)
                                                )
                                                .join(" "),
                                              SAAFirstNameErr: "",
                                            })
                                          }
                                          maxLength={30}
                                          disabled={SameAsAbove || isEditMode}
                                        />
                                        {
                                          <span className="text-danger text-start text-left d-block mt-1">
                                            {SAAFirstNameErr}
                                          </span>
                                        }
                                        <span class="floating-label-outside">
                                          First Name{" "}
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={SAALastName}
                                          type="text"
                                          class="outside"
                                          required
                                          onChange={(e) =>
                                            this.setState({
                                              SAALastName: e.target.value
                                                .replace(/[^a-zA-Z\s]/g, "")
                                                .replace(/\s+/g, " ")
                                                .split(" ")
                                                .map(
                                                  (word) =>
                                                    word
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    word.slice(1)
                                                )
                                                .join(" "),
                                              SAALastNameErr: "",
                                            })
                                          }
                                          maxLength={30}
                                          disabled={SameAsAbove || isEditMode}
                                        />
                                        {
                                          <span className="text-danger text-start text-left d-block mt-1">
                                            {SAALastNameErr}
                                          </span>
                                        }

                                        <span class="floating-label-outside">
                                          Last Name{" "}
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          type="text"
                                          value={SAADesignation}
                                          class="outside"
                                          required
                                          // onKeyDown={(e) => this.handleKeyDown(e)}
                                          onChange={(e) =>
                                            this.setState({
                                              SAADesignation: e.target.value
                                                .split(" ")
                                                .map(
                                                  (word) =>
                                                    word
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    word.slice(1)
                                                )
                                                .join(" "),
                                            })
                                          }
                                          disabled={SameAsAbove || isEditMode}
                                          maxLength={50}
                                        />

                                        <span class="floating-label-outside">
                                          Designation{" "}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-12">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={SAACompanyName}
                                          type="text"
                                          class="outside"
                                          required
                                          disabled={SameAsAbove || isEditMode}
                                          onChange={(e) =>
                                            this.setState({
                                              SAACompanyName: e.target.value
                                                .split(" ")
                                                .map(
                                                  (word) =>
                                                    word
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    word.slice(1)
                                                )
                                                .join(" "),
                                              SAACompanyNameErr: "",
                                            })
                                          }
                                          maxLength={100}
                                        />
                                        {
                                          <span className="text-danger text-start text-left d-block mt-1">
                                            {SAACompanyNameErr}
                                          </span>
                                        }
                                        {isVendorLogin ? (
                                          <>
                                            <span class="floating-label-outside">
                                              Vendor Name{" "}
                                              <span class="mendatory_class">
                                                *
                                              </span>
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            <span class="floating-label-outside">
                                              Organizer / Organization Name{" "}
                                              <span class="mendatory_class">
                                                *
                                              </span>
                                            </span>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="form-group floating-group floating-diff ">
                                      <select
                                        id="state disable-bg"
                                        name="Entry Type"
                                        class="form-control floating-control"
                                        // style={{ background: '#f7f7f7' }}
                                        value={SAACountryId}
                                        disabled={SameAsAbove || isEditMode}
                                        style={{
                                          background:
                                            SameAsAbove || isEditMode
                                              ? "#FAFAFA"
                                              : "",
                                        }}
                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                        onChange={(e) => this.onSAACountryId(e)}
                                      >
                                        <option>
                                          Country
                                          <span class="mendatory_class">*</span>
                                        </option>

                                        {countryList.length > 0 &&
                                          countryList.map((item) => (
                                            <option
                                              key={item.Countryid}
                                              value={item.Countryid}
                                            >
                                              {item.CountryName}
                                            </option>
                                          ))}
                                      </select>
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {SAACountryIdErr}
                                        </span>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={SAAStateId}
                                          type="text"
                                          // onKeyDown={(e) => this.handleKeyDown(e)}
                                          class="outside"
                                          required
                                          onChange={(e) =>
                                            this.onSAAStateSearch(e)
                                          }
                                          autocomplete="off"
                                          maxLength={30}
                                          disabled={SameAsAbove || isEditMode}
                                        />
                                        {isSAADisplayStateList &&
                                          this.renderSAAStateList()}
                                        {
                                          <span className="text-danger text-start text-left d-block mt-1">
                                            {SAAStateErr}
                                          </span>
                                        }
                                        <span class="floating-label-outside">
                                          State{" "}
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={SAACityId}
                                          type="text"
                                          // onKeyDown={(e) => this.handleKeyDown(e)}
                                          class="outside"
                                          required
                                          onChange={(e) =>
                                            this.onSAACitytSearch(e)
                                          }
                                          autocomplete="off"
                                          disabled={SameAsAbove || isEditMode}
                                          maxLength={30}
                                        />
                                        {isSAADisplayCityList &&
                                          this.renderSAACityList()}
                                        {
                                          <span className="text-danger text-start text-left d-block mt-1">
                                            {SAACityNameErr}
                                          </span>
                                        }
                                        <span class="floating-label-outside">
                                          City{" "}
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={SAAAddressLine1}
                                          type="text"
                                          class="outside"
                                          required
                                          // onKeyDown={(e) => this.handleKeyDown(e)}
                                          onChange={(e) =>
                                            this.setState({
                                              SAAAddressLine1: e.target.value
                                                .split(" ")
                                                .map(
                                                  (word) =>
                                                    word
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    word.slice(1)
                                                )
                                                .join(" "),
                                              SAAAddressLine1Err: "",
                                            })
                                          }
                                          disabled={SameAsAbove || isEditMode}
                                          maxLength={70}
                                        />
                                        {
                                          <span className="text-danger text-start text-left d-block mt-1">
                                            {SAAAddressLine1Err}
                                          </span>
                                        }

                                        <span class="floating-label-outside">
                                          Address Line 1{" "}
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          type="text"
                                          value={SAAAddressLine2}
                                          class="outside"
                                          required
                                          // onKeyDown={(e) => this.handleKeyDown(e)}
                                          onChange={(e) =>
                                            this.setState({
                                              SAAAddressLine2: e.target.value
                                                .split(" ")
                                                .map(
                                                  (word) =>
                                                    word
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    word.slice(1)
                                                )
                                                .join(" "),
                                            })
                                          }
                                          disabled={SameAsAbove || isEditMode}
                                          maxLength={70}
                                        />

                                        <span class="floating-label-outside">
                                          Address Line 2{" "}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={SAAPincode}
                                          type="text"
                                          class="outside"
                                          required
                                          // onKeyDown={(e) => this.handleKeyDown(e)}
                                          onChange={(e) =>
                                            this.setState({
                                              SAAPincode:
                                                e.target.value.replace(
                                                  /\D/,
                                                  ""
                                                ),
                                              SAAPincodeErr: "",
                                            })
                                          }
                                          disabled={SameAsAbove || isEditMode}
                                          maxLength={
                                            countryId == "91" ||
                                              countryId == "" ||
                                              countryId == "Country*"
                                              ? 6
                                              : 35
                                          }
                                        />
                                        {
                                          <span className="text-danger text-start text-left d-block mt-1">
                                            {SAAPincodeErr}
                                          </span>
                                        }

                                        <span class="floating-label-outside">
                                          {SAACountryId == "91" ||
                                            SAACountryId == "" ||
                                            SAACountryId == "Country*"
                                            ? "Pincode"
                                            : "ZipCode"}
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="tel_number">
                                        <div class="ISD">
                                          <input
                                            type="text"
                                            class="outside"
                                            placeholder="ISD"
                                            required
                                            value={SAAISD}
                                            disabled={true}
                                          />
                                        </div>
                                        <div class="position-relative width_80">
                                          <input
                                            value={SAAMobile1}
                                            type="text"
                                            class="outside"
                                            required
                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                            onChange={(e) =>
                                              this.setState({
                                                SAAMobile1:
                                                  e.target.value.replace(
                                                    /\D/,
                                                    ""
                                                  ),
                                                SAAMobile1Err: "",
                                              })
                                            }
                                            maxLength={10}
                                            disabled={SameAsAbove || isEditMode}
                                          />
                                          {
                                            <span className="text-danger text-start text-left d-block mt-1">
                                              {SAAMobile1Err}
                                            </span>
                                          }
                                          <span class="floating-label-outside">
                                            Mobile 1{" "}
                                            <span class="mendatory_class">
                                              *
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="tel_number">
                                        <div class="ISD">
                                          <input
                                            type="text"
                                            class="outside"
                                            placeholder="ISD"
                                            required
                                            value={SAAISD}
                                            disabled={true}
                                          />
                                        </div>
                                        <div class="position-relative width_80">
                                          <input
                                            value={SAAMobile2}
                                            type="text"
                                            class="outside"
                                            required
                                            // onKeyDown={(e) => this.handleKeyDown(e)}
                                            onChange={(e) =>
                                              this.setState({
                                                SAAMobile2:
                                                  e.target.value.replace(
                                                    /\D/,
                                                    ""
                                                  ),
                                              })
                                            }
                                            maxLength={
                                              countryId == "91" ? 10 : 11
                                            }
                                            disabled={SameAsAbove || isEditMode}
                                          />

                                          <span class="floating-label-outside">
                                            Mobile 2{" "}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="tel_number">
                                        <div class="ISD">
                                          <input type="text" class="outside"
                                            onChange={(e) => this.setState({ preTel: e.target.value })}
                                            placeholder={SAACountryId == '91' || SAACountryId == '' || SAACountryId == 'Country*' ? 'STD' : 'ISD'}
                                            value={SAAPreTel} required
                                            disabled={SameAsAbove || isEditMode}
                                          />
                                        </div>
                                        {SAACountryId != '91' && SAACountryId != '' && SAACountryId != 'Country*' ?
                                          <div class="ISD">
                                            <input type="text" class="outside"
                                              onChange={(e) => this.setState({ SAAAreaCode: e.target.value })}
                                              placeholder='CODE'
                                              value={SAAAreaCode} required
                                              disabled={SameAsAbove || isEditMode}
                                            />
                                          </div>
                                          : <></>}
                                        <div class="position-relative width_80">
                                          <input value={SAATelephoneNumber}
                                            // onKeyDown={(e) => this.handleKeyDown(e)} 
                                            type="text" class="outside" required
                                            onChange={(e) => this.setState({ SAATelephoneNumber: e.target.value.replace(/\D/, '') })}
                                            disabled={SameAsAbove || isEditMode}
                                            maxLength={16}
                                          />
                                          <span class="floating-label-outside">Telephone Number </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          type="text"
                                          value={SAAPrimaryEmailID}
                                          class="outside"
                                          required
                                          // onKeyDown={(e) => this.handleKeyDown(e)}
                                          onChange={(e) =>
                                            this.setState({
                                              SAAPrimaryEmailID: e.target.value,
                                              SAAPrimaryEmailIDErr: "",
                                            })
                                          }
                                          disabled={SameAsAbove || isEditMode}
                                          maxLength={100}
                                        />
                                        {
                                          <span className="text-danger text-start text-left d-block mt-1">
                                            {SAAPrimaryEmailIDErr}
                                          </span>
                                        }

                                        <span class="floating-label-outside">
                                          Primary Email ID{" "}
                                          <span class="mendatory_class">*</span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={SAASecondaryEmailID}
                                          type="text"
                                          class="outside"
                                          required
                                          // onKeyDown={(e) => this.handleKeyDown(e)}
                                          onChange={(e) =>
                                            this.setState({
                                              SAASecondaryEmailID:
                                                e.target.value,
                                            })
                                          }
                                          disabled={SameAsAbove || isEditMode}
                                          maxLength={100}
                                        />

                                        <span class="floating-label-outside">
                                          Secondary Email ID{" "}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <div class="position-relative">
                                        <input
                                          value={SAAWebsite}
                                          type="text"
                                          class="outside"
                                          required
                                          // onKeyDown={(e) => this.handleKeyDown(e)}
                                          onChange={(e) =>
                                            this.setState({
                                              SAAWebsite: e.target.value,
                                            })
                                          }
                                          disabled={SameAsAbove || isEditMode}
                                          maxLength={40}
                                        />

                                        <span class="floating-label-outside">
                                          Website{" "}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </fieldset>
                          </>
                        )}
                        {countryId == "91" ? (
                          <fieldset>
                            {isVendorLogin ? (
                              <legend>Vendor's Information</legend>
                            ) : (
                              <legend>
                                Organizer's / Organization's Information
                              </legend>
                            )}

                            <div class="outside_input_field ">
                              <div class="row">
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <div class="position-relative">
                                      <input
                                        value={registrationNumber}
                                        type="text"
                                        class="outside"
                                        required
                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                        onChange={(e) =>
                                          this.setState({
                                            registrationNumber:
                                              e.target.value.toUpperCase(),
                                          })
                                        }
                                        maxLength={20}
                                        disabled={isEditMode}
                                      />
                                      <span class="floating-label-outside">
                                        Registration Number{" "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <div class="position-relative">
                                      <input
                                        value={PANCardNo}
                                        type="text"
                                        class="outside"
                                        required
                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                        onChange={(e) =>
                                          this.setState({
                                            PANCardNo:
                                              e.target.value.toUpperCase(),
                                            PANCardNoErr: "",
                                          })
                                        }
                                        maxLength={10}
                                        disabled={isEditMode}
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {PANCardNoErr}
                                        </span>
                                      }
                                      <span class="floating-label-outside">
                                        PAN Card No.{" "}
                                        <span class="mendatory_class">*</span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <div class="position-relative">
                                      <input
                                        value={NameonPANCard}
                                        type="text"
                                        class="outside"
                                        required
                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                        onChange={(e) =>
                                          this.setState({
                                            NameonPANCard: e.target.value
                                              .replace(/[^a-zA-Z\s]/g, "")
                                              .replace(/\s+/g, " ")
                                              .split(" ")
                                              .map(
                                                (word) =>
                                                  word.charAt(0).toUpperCase() +
                                                  word.slice(1)
                                              )
                                              .join(" "),
                                            NameonPANCardErr: "",
                                          })
                                        }
                                        disabled={isEditMode}
                                        maxLength={50}
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {NameonPANCardErr}
                                        </span>
                                      }
                                      <span class="floating-label-outside">
                                        Name on PAN Card{" "}
                                        <span class="mendatory_class">*</span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <div class="position-relative">
                                      <input
                                        value={GSTNo}
                                        type="text"
                                        class="outside"
                                        required
                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                        onChange={(e) =>
                                          this.setState({
                                            GSTNo: e.target.value.toUpperCase(),
                                          })
                                        }
                                        disabled={isEditMode}
                                      />
                                      <span class="floating-label-outside">
                                        GST No.{" "}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="form-group">
                                    <div class="position-relative">
                                      <input
                                        value={TANNumber}
                                        type="text"
                                        class="outside"
                                        required
                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                        onChange={(e) =>
                                          this.setState({
                                            TANNumber:
                                              e.target.value.toUpperCase(),
                                          })
                                        }
                                        maxLength={20}
                                        disabled={isEditMode}
                                      />
                                      <span class="floating-label-outside">
                                        TAN Number{" "}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="form-group">
                                    <div class="position-relative">
                                      <input
                                        value={UINNumber}
                                        type="text"
                                        class="outside"
                                        required
                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                        onChange={(e) =>
                                          this.setState({
                                            UINNumber:
                                              e.target.value.toUpperCase(),
                                          })
                                        }
                                        maxLength={20}
                                        disabled={isEditMode}
                                      />
                                      <span class="floating-label-outside">
                                        UIN Number{" "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </fieldset>
                        ) : (
                          <></>
                        )}
                        <fieldset>
                          <legend>Banking details</legend>
                          <div class="outside_input_field ">
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={accountName}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) =>
                                        this.setState({
                                          accountName: e.target.value
                                            .split(" ")
                                            .map(
                                              (word) =>
                                                word.charAt(0).toUpperCase() +
                                                word.slice(1)
                                            )
                                            .join(" "),
                                          accountNameErr: "",
                                        })
                                      }
                                      disabled={isEditMode}
                                      maxLength={50}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {accountNameErr}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      Account Name{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={accountNo}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) =>
                                        this.setState({
                                          accountNo: e.target.value.replace(
                                            /\D/,
                                            ""
                                          ),
                                          accountNoErr: "",
                                        })
                                      }
                                      maxLength={30}
                                      disabled={isEditMode}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {accountNoErr}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      Account No.{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group floating-group floating-diff">
                                  <select
                                    id="state"
                                    name="Entry Type"
                                    class="form-control floating-control"
                                    value={accountType}
                                    disabled={isEditMode}
                                    onChange={(e) =>
                                      this.setState({
                                        accountType: e.target.value,
                                        accountTypeErr: "",
                                      })
                                    }
                                  >
                                    <option>
                                      Account Type
                                      <span class="mendatory_class">*</span>
                                    </option>

                                    {accountTypeList.length > 0 &&
                                      accountTypeList.map((item) => (
                                        <option>{item.Accounttype}</option>
                                      ))}
                                  </select>
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {accountTypeErr}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={bankName}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) =>
                                        this.setState({
                                          bankName: e.target.value
                                            .split(" ")
                                            .map(
                                              (word) =>
                                                word.charAt(0).toUpperCase() +
                                                word.slice(1)
                                            )
                                            .join(" "),
                                          bankNameErr: "",
                                        })
                                      }
                                      disabled={isEditMode}
                                      maxLength={50}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {bankNameErr}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      Bank name{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={branchName}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) =>
                                        this.setState({
                                          branchName: e.target.value
                                            .split(" ")
                                            .map(
                                              (word) =>
                                                word.charAt(0).toUpperCase() +
                                                word.slice(1)
                                            )
                                            .join(" "),
                                          branchNameErr: "",
                                        })
                                      }
                                      disabled={isEditMode}
                                      maxLength={30}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {branchNameErr}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      branch name{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={IFSCCode}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) =>
                                        this.setState({
                                          IFSCCode:
                                            e.target.value.toUpperCase(),
                                          IFSCCodeErr: "",
                                        })
                                      }
                                      maxLength={20}
                                      disabled={isEditMode}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {IFSCCodeErr}
                                      </span>
                                    }

                                    <span class="floating-label-outside">
                                      {countryId == "91" ||
                                        countryId == "" ||
                                        countryId == "Country*"
                                        ? "IFSC code"
                                        : "Swift code"}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </fieldset>
                        {isVendorLogin == true ? (
                          <>
                          <fieldset>
                            <legend>Service Offered</legend>
                            <div class="outside_input_field ">
                              <div class="row">
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <div class="position-relative">
                                      <div class="form-group floating-group floating-diff">
                                        <label>Services</label>
                                        <Select
                                          isMulti
                                          isDisabled
                                          value={
                                            ExternalServices ||
                                            ExternalServicesListTable
                                          }
                                          styles={customStyles}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div className="col-md-12">
                                  <table
                                    class="table table-bordered table-striped"
                                    id="tbl"
                                  >
                                    <thead>
                                      <tr className="text-center">
                                        <th>SERVICE</th>
                                        <th>CITY</th>
                                        <th>PACKAGE</th>
                                        <th>PACKAGE DETAILS</th>
                                        <th>IMAGES</th>
                                        <th>ITME MARGIN %</th>
                                      </tr>
                                    </thead>
                                    <tbody id="myTable">
                                      {servicePackageList.length > 0 ? (
                                        servicePackageList.map(
                                          (data, index) => (
                                            <tr
                                              key={index}
                                              className="text-center"
                                            >
                                              <td>
                                                {ExternalServicesListTable.find(
                                                  (service) =>
                                                    service.value ===
                                                    parseInt(data.ServiceID)
                                                ).label || data.ServiceID}
                                              </td>
                                              <td>
                                                {cityList.find(
                                                  (city) =>
                                                    city.CityName === data.City
                                                )?.CityName || ""}
                                              </td>
                                              <td>{data.Package}</td>
                                              <td className="text-center">
                                                <i
                                                  className="fa fa-table action_btn_table"
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    this.togglePackageDetailsModal(
                                                      data.PackageDetails,
                                                      data.Package
                                                    )
                                                  }
                                                ></i>
                                              </td>
                                              <td className="text-center">
                                                <i className="fa fa-image action_btn_table"></i>
                                              </td>
                                              <td className="text-center">
                                                {data.ITME_Margin}
                                              </td>
                                            </tr>
                                          )
                                        )
                                      ) : (
                                        <tr>
                                          <td colSpan="8">
                                            No data available.
                                          </td>
                                        </tr>
                                      )}{" "}
                                    </tbody>
                                  </table>

                                  <Modal
                                    show={showDetails}
                                    // onHide={this.togglePackageDetailsModal}
                                    size="lg"
                                  >
                                    <Modal.Header>
                                      <Modal.Title>{Package}</Modal.Title>
                                      <span
                                        onClick={() =>
                                          this.togglePackageDetailsModal()
                                        }
                                        style={{
                                          cursor: "pointer",
                                          fontWeight: "800",
                                        }}
                                      >
                                        X
                                      </span>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <div className="modal-body">
                                        <div>
                                          <pre
                                            dangerouslySetInnerHTML={{
                                              __html: showPackageDetails,
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button
                                        variant="secondary"
                                        onClick={() =>
                                          this.togglePackageDetailsModal()
                                        }
                                      >
                                        {" "}
                                        Close
                                      </Button>
                                    </Modal.Footer>
                                  </Modal>
                                </div>
                              </div>
                            </div>
                          </fieldset>
                           <fieldset>
                           <legend>Material Wise List</legend>
                           <div class="row">
                             <div class="col-md-12">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="custom_table">
                                     <div class="hack1">
                                       <div class="hack2">
                                         <table
                                           class="table table-bordered table-striped"
                                           id="tbl"
                                         >
                                           <thead>
                                             <tr>
                                               <th style={{ width: "10%" }}>
                                                 Sr. no
                                               </th>
                                               <th style={{ width: "30%" }}>
                                                 Service Name
                                               </th>
                                               <th style={{ width: "30%" }}>
                                                 Material Name
                                               </th>
                                               <th style={{ width: "20%" }}>
                                                 Quantity
                                               </th>
                                             </tr>
                                           </thead>
                                           <tbody id="myTable">
                                             {materialList.length > 0 ? (
                                               materialList.map((data, index) => (
                                                 <tr key={index}>
                                                   <td>{index + 1}</td>
                                                   <td>{
                                                   (() => {
                                                      const externalServiceData =
                                                        ExternalServicesList.find(
                                                          (item) =>
                                                            item.value ===
                                                            parseInt(
                                                              data.ServiceID
                                                            )
                                                        );
                                                      return externalServiceData
                                                        ? `${externalServiceData.label}`
                                                        : "";
                                                    })()}
                                                   </td>
                                                   <td>
                                                     
                                                       {data.Name}
                                                   </td>
                                                   <td>
                                                     {data.Quantity}
                                                   </td>
                                                   
                                                 </tr>
                                               ))
                                             ) : (
                                               <tr>
                                                 <td colSpan="6">
                                                   No data available.
                                                 </td>
                                               </tr>
                                             )}
                                            
                                           </tbody>
                                         </table>
                                         
                                       </div>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                             </div>
                           </div>
                         </fieldset>
                         </>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div className="row">
                        <div className="mx-3">
                          {isEditMode == false ? (
                            <a
                              href="javascript:void(0);"
                              onClick={() => this.handleSubmit()}
                              className="btn save_btn"
                            >
                              Save
                            </a>
                          ) : isVendorLogin == true ? (
                            <a
                              href="javascript:void(0);"
                              onClick={() => {
                                this.props.navigate("/thirdPartyOrderList");
                              }}
                              className="btn save_btn"
                            >
                              Cancel
                            </a>
                          ) : (
                            <a
                              href="javascript:void(0);"
                              onClick={() => {
                                this.props.navigate("/normalView");
                              }}
                              className="btn save_btn"
                            >
                              Cancel
                            </a>
                          )}
                        </div>
                        <div className="mx-3">
                          {/* <a
                                          href="javascript:void(0);"
                                          onClick={() =>
                                            this.setState({
                                              isAccordionExpanded:
                                                !isAccordionExpanded,
                                            })
                                          }
                                          className="btn back_btn"
                                        >
                                          Close
                                        </a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <ToastContainer />
          <style type="text/css">{floatingLabelCSS}</style>
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    get_company_info_Details_action,
    fill_action,
    company_info_add_update_action,
    vendor_detail_action,
  })(Profile)
);
